function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import Badge from "react-bootstrap/Badge";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import Tooltip from "react-bootstrap/Tooltip";
import moment from "moment-timezone";
import { FilterContext, UserContext } from "../index";
import "./ViewLeave.css";
import Loader from "./../Loader/Loader";
import { Chart } from "react-google-charts";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import GenerateToken from "./../img/generate-token.jpg";
import Modal from "react-bootstrap/Modal";
import { Field, Form, Formik, FieldArray } from "formik";
import * as Yup from "yup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Select from "react-select";
import DatePicker from "react-datepicker";
import Popover from "react-bootstrap/Popover";
import { stringToArrayOutput } from "./../SideMenu/Header.js";
import { MdDateRange } from "react-icons/md";
import { FaCalendarPlus } from "react-icons/fa";
import { HiPlus } from "react-icons/hi";
import { GoCalendar } from "react-icons/go";
import TimePicker from "rc-time-picker";
import { MdInfoOutline } from "react-icons/md";
import { FaRegFilePdf } from "react-icons/fa";
import { ADD_LEAVE_DETAILS_MUTATION, ADD_LEAVE_ATTACHMENT_MUTATION, DELETE_LEAVE_ATTACHMENT_MUTATION, LEAVE_LIST_QUERY, LEAVE_CHART_QUERY, EDIT_LEAVE_DETAILS_MUTATION, DELETE_LEAVE_DETAILS_MUTATION, LEAVE_LIST_COUNT_QUERY, LIST_LEAVE_TYPE_QUERY, LEAVE_TYPE_SETTINGS_LIST_QUERY, LEAVE_SETTINGS_APPROVED_LIST_QUERY, ADD_PERMISSION_DETAILS_MUTATION, LIST_PERMISSION_TYPE_QUERY, DELETE_PERMISSION_DETAILS_MUTATION, EDIT_PERMISSION_DETAILS_MUTATION, GET_PRE_SIGNED_URL, USER_WORK_DAY_SETTINGS_QUERY_FOR_LEAVE } from "./query";
import { USER_WORK_DAY_SETTINGS_QUERY } from "./../Employees/query";
import { useQuery, useMutation, useLazyQuery, useApolloClient } from "@apollo/client";
import { toast } from "react-toastify";
import { HOLIDAY_LIST_QUERY } from "./../HolidayImport/query";
import { VscLoading, VscClose } from "react-icons/vsc";
import classNames from "classnames";
import Table from "react-bootstrap/Table";
import format from "date-fns/format";
import { convertSecToHoursAndMinutesWithTextForm, decodeHtmlEntities, encodeHtmlEntities, isRateLimited, rateLimitMessage } from "../utils";
import { GET_USER_LISTING_QUERY } from "./../AdminViewLeave/query";
import { arrayToStringOutput as arrayToStringOutputFilter } from "./../LeaveHistory/LeaveHistory.js";
import { RiCloseCircleFill } from "react-icons/ri";
import { LeaveManagementEnableFeature } from "./../AdminViewLeave/AdminViewLeave";
import { FiCalendar, FiUpload, FiDownload, FiInfo, FiCheckCircle } from "react-icons/fi";
var ViewLeave = function ViewLeave(props) {
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var _React$useState = React.useState("upcoming"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeTab = _React$useState2[0],
    setActiveTab = _React$useState2[1];
  var currentYear = moment().format("YYYY");
  var _React$useState3 = React.useState(stringToArrayOutput("Free Plan Days")),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    last14Days = _React$useState4[0],
    setLast14Days = _React$useState4[1];
  var _React$useState5 = React.useState(new Date()),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    leaveBalanceStartDate = _React$useState6[0],
    setLeaveBalanceStartDate = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    leaveBalanceEndDate = _React$useState8[0],
    setLeaveBalanceEndDate = _React$useState8[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var _useQuery = useQuery(LEAVE_TYPE_SETTINGS_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        startTime: Number(leaveBalanceStartDate),
        endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate)
      },
      skip: !organisationId
    }),
    leaveSettingData = _useQuery.data,
    leaveSettingError = _useQuery.error,
    leaveSettingLoading = _useQuery.loading,
    listSettingRefetch = _useQuery.refetch;
  return /*#__PURE__*/React.createElement("div", {
    className: "view-leave-root"
  }, !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined ? /*#__PURE__*/React.createElement(LeaveManagementEnableFeature, {
    displayName: user === null || user === void 0 ? void 0 : user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history,
    role: role
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "view-leave-whole-div"
  }, /*#__PURE__*/React.createElement(LeaveTypeCards, {
    organisationId: organisationId,
    location: props.location,
    organisationSettings: organisationSettings,
    leaveBalanceStartDate: leaveBalanceStartDate,
    setLeaveBalanceStartDate: setLeaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    setLeaveBalanceEndDate: setLeaveBalanceEndDate,
    leaveSettingData: leaveSettingData,
    leaveSettingError: leaveSettingError,
    leaveSettingLoading: leaveSettingLoading,
    listSettingRefetch: listSettingRefetch
  })), /*#__PURE__*/React.createElement(LeaveListing, {
    organisationId: organisationId,
    userId: user.userId,
    organisationSettings: organisationSettings,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    role: role,
    currentYear: currentYear,
    workingDays: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.workingDays,
    organisationBilling: organisationBilling,
    last14Days: last14Days,
    leaveBalanceStartDate: leaveBalanceStartDate,
    setLeaveBalanceStartDate: setLeaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    setLeaveBalanceEndDate: setLeaveBalanceEndDate,
    leaveSettingData: leaveSettingData,
    leaveSettingLoading: leaveSettingLoading
  })));
};
var ColumnNameList = ["Leave Type", "Available Leave", "Taken Leave", "Validity"];
var LeaveTypeCards = function LeaveTypeCards(props) {
  var _leaveSettingData$lea, _leaveSettingData$lea2;
  var organisationId = props.organisationId,
    location = props.location,
    organisationSettings = props.organisationSettings,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    setLeaveBalanceStartDate = props.setLeaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    setLeaveBalanceEndDate = props.setLeaveBalanceEndDate,
    leaveSettingData = props.leaveSettingData,
    leaveSettingError = props.leaveSettingError,
    leaveSettingLoading = props.leaveSettingLoading,
    listSettingRefetch = props.listSettingRefetch;
  React.useEffect(function () {
    if (location !== null && location !== void 0 && location.key) {
      listSettingRefetch === null || listSettingRefetch === void 0 ? void 0 : listSettingRefetch();
    }
  }, [location]);
  React.useEffect(function () {
    listSettingRefetch === null || listSettingRefetch === void 0 ? void 0 : listSettingRefetch();
  }, [leaveBalanceStartDate, leaveBalanceEndDate]);
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "leave-type-card-root"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "leave-type-text-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-type-text-header-apply"
  }, "Leave Balance as of", " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(TimeFilterBalance, {
      onClose: hideOverlay,
      leaveBalanceStartDate: leaveBalanceStartDate,
      setLeaveBalanceStartDate: setLeaveBalanceStartDate,
      leaveBalanceEndDate: leaveBalanceEndDate,
      setLeaveBalanceEndDate: setLeaveBalanceEndDate
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter-apply",
    className: "leave-listing-filter-date-picker-filter-date-apply leave-listing-filter-div-field-input-apply"
  }, /*#__PURE__*/React.createElement(MdDateRange, {
    className: "leave-listing-filter-date-picker-filter-date-icon-apply"
  }), leaveBalanceStartDate && leaveBalanceEndDate ? /*#__PURE__*/React.createElement("p", {
    className: "leave-listing-filter-date-picker-filter-date-text-apply"
  }, arrayToStringOutputApply([Number(leaveBalanceStartDate), Number(leaveBalanceEndDate)], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) : leaveBalanceStartDate ? /*#__PURE__*/React.createElement("p", {
    className: "leave-listing-filter-date-picker-filter-date-text-apply"
  }, arrayToStringOutputApply([Number(leaveBalanceStartDate), Number(leaveBalanceStartDate)], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) : /*#__PURE__*/React.createElement("p", {
    className: "leave-listing-filter-date-picker-filter-date-text-apply"
  }, "Select Date"))))), leaveSettingLoading ? /*#__PURE__*/React.createElement(Loader, null) : leaveSettingError ? /*#__PURE__*/React.createElement("div", null, "Something went wrong") : (leaveSettingData === null || leaveSettingData === void 0 ? void 0 : (_leaveSettingData$lea = leaveSettingData.leaveTypeCardLists) === null || _leaveSettingData$lea === void 0 ? void 0 : _leaveSettingData$lea.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "leave-type-table-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-type-card-apply-leave-page"
  }, leaveSettingData === null || leaveSettingData === void 0 ? void 0 : (_leaveSettingData$lea2 = leaveSettingData.leaveTypeCardLists) === null || _leaveSettingData$lea2 === void 0 ? void 0 : _leaveSettingData$lea2.map(function (data) {
    var nameSplit = data.leaveTypeName.split(" ");
    "";
    return /*#__PURE__*/React.createElement("div", {
      className: "leave-type-card-apply-leave-page-card"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, data.leaveTypeName.charAt(0).toUpperCase() + data.leaveTypeName.slice(1))
    }, /*#__PURE__*/React.createElement("p", {
      className: "leave-type-card-apply-leave-page-card-p-header"
    }, data.leaveTypeName.charAt(0).toUpperCase() + data.leaveTypeName.slice(1))), /*#__PURE__*/React.createElement("div", {
      className: "leave-type-card-apply-leave-page-card-header-icon"
    }, data.leaveTypeName.charAt(0).toUpperCase(), nameSplit.length >= 2 ? nameSplit[1].charAt(0).toUpperCase() : ""), /*#__PURE__*/React.createElement("p", {
      className: "leave-type-card-apply-leave-page-card-p"
    }, data.leaveTypeCount || data.leaveTypeCount == 0 ? data.available || data.available == 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "leave-type-card-apply-leave-page-card-span"
    }, "Available:"), " ", Number(data.available), " ", Number(data.available) !== 0 && Number(data.available) !== 1 ? "days" : "day") : data.takenLeave ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "leave-type-card-apply-leave-page-card-span"
    }, "Available:"), " ", Number(data.leaveTypeCount) - Number(data.takenLeave) >= 0 ? Number(data.leaveTypeCount) - Number(data.takenLeave) : 0, " ", Number(data.leaveTypeCount) - Number(data.takenLeave) !== 1 && Number(data.leaveTypeCount) - Number(data.takenLeave) !== 0 ? "days" : "day") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "leave-type-card-apply-leave-page-card-span"
    }, "Available:"), " ", Number(data.leaveTypeCount), " ", Number(data.leaveTypeCount) !== 0 && Number(data.leaveTypeCount) !== 1 ? "days" : "day") : /*#__PURE__*/React.createElement("span", {
      className: "leave-type-card-apply-leave-page-card-span"
    }, "Unlimited Leave")), /*#__PURE__*/React.createElement("p", {
      className: "leave-type-card-apply-leave-page-card-p"
    }, data.takenLeave ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "leave-type-card-apply-leave-page-card-span"
    }, "Booked: "), " ", data.takenLeave, " ", data.takenLeave !== 0 && data.takenLeave !== 1 ? "days" : "day") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "leave-type-card-apply-leave-page-card-span"
    }, "Booked: "), "0 day")), /*#__PURE__*/React.createElement("p", {
      className: "leave-type-card-apply-leave-page-card-p"
    }, /*#__PURE__*/React.createElement("span", {
      className: "leave-type-card-apply-leave-page-card-span"
    }, "Period: "), " ", data.resetType == "Annually" ? "".concat(moment(leaveBalanceStartDate).format("YYYY"), " (Yearly)") : leaveBalanceEndDate ? "".concat(moment(leaveBalanceStartDate).format("MMM"), " - ").concat(moment(leaveBalanceEndDate).format("MMM")) : "".concat(moment(leaveBalanceStartDate).format("MMMM"))));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-no-data-text-view"
  }, "Yet to add leave types"));
};
var LeaveChart = function LeaveChart(props) {
  var organisationBilling = props.organisationBilling,
    organisationId = props.organisationId,
    organisationSettings = props.organisationSettings,
    userId = props.userId,
    currentYear = props.currentYear,
    location = props.location;
  var _useQuery2 = useQuery(LEAVE_CHART_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: userId,
        year: currentYear,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      skip: !organisationId
    }),
    leaveChartData = _useQuery2.data,
    leaveChartError = _useQuery2.error,
    leaveChartLoading = _useQuery2.loading,
    leaveChartRefetch = _useQuery2.refetch;
  React.useEffect(function () {
    if (location !== null && location !== void 0 && location.key) {
      leaveChartRefetch === null || leaveChartRefetch === void 0 ? void 0 : leaveChartRefetch();
    }
  }, [location]);
  var workTimeSummaryChart = leaveChartData !== null && leaveChartData !== void 0 && leaveChartData.leaveSummary ? leaveChartData === null || leaveChartData === void 0 ? void 0 : leaveChartData.leaveSummary.reduce(function (acc, curr) {
    var appliedLeave = curr.appliedLeave,
      approvedLeave = curr.approvedLeave,
      pendingLeave = curr.pendingLeave,
      rejectedLeave = curr.rejectedLeave,
      date = curr.date;
    return [].concat(_toConsumableArray(acc), [[date, approvedLeave !== null ? approvedLeave : 0, "<div class=\"apps-tootlip\">\n        <span class=\"apps-tootlip-title\">Approved Leave</span>\n        <br>\n        <span class=\"apps-tootlip apps-tootlip-time\">Leave count: ".concat(approvedLeave !== null ? approvedLeave : 0, "</span>\n      </div>"), pendingLeave !== null ? pendingLeave : 0, "<div class=\"apps-tootlip\">\n        <span class=\"apps-tootlip-title\">Pending Leave</span>\n        <br>\n        <span class=\"apps-tootlip apps-tootlip-time\">Leave count: ".concat(pendingLeave !== null ? pendingLeave : 0, "</span>\n      </div>"), rejectedLeave !== null ? rejectedLeave : 0, "<div class=\"apps-tootlip\">\n          <span class=\"apps-tootlip-title\">Rejected Leave</span>\n          <br>\n          <span class=\"apps-tootlip apps-tootlip-time\">Leave count: ".concat(rejectedLeave !== null ? rejectedLeave : 0, "</span>\n        </div>")]]);
  }, [["Date", "approvedLeave", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "pendingLeave", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "rejectedLeave", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]]) : [["Date", "approvedLeave", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "pendingLeave", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "rejectedLeave", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]];
  return /*#__PURE__*/React.createElement("div", {
    className: "view-leave-chart-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-leave-chart-div-whole-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-leave-chart-div-header"
  }, "Time Off Trend ")), leaveChartLoading ? /*#__PURE__*/React.createElement(Loader, null) : leaveChartError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "230px",
    left: "10px",
    right: "10px",
    chartType: "ColumnChart",
    loader: /*#__PURE__*/React.createElement("div", {
      className: "project-details-chart-loader"
    }, "Loading Chart"),
    data: workTimeSummaryChart,
    options: {
      title: "",
      chartArea: {
        width: "85%"
      },
      isStacked: true,
      vAxis: {
        minValue: 0,
        title: "Days",
        stroke: "none",
        strokeWidth: "0"
      },
      hAxis: {
        baselineColor: "red"
      },
      backgroundColor: "#fcfcfc",
      legend: "none",
      padding: {
        right: 10,
        bottom: 20,
        left: 20
      },
      colors: ["#27ae60", "#f1c40f", "#E67E22"],
      tooltip: {
        isHtml: true,
        trigger: "visible"
      }
    }
    // For tests
    ,
    rootProps: {
      "data-testid": "3"
    }
  })) : /*#__PURE__*/React.createElement("div", {
    className: "view-leave-chart-demo-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-leave-chart-demo-div-text"
  }, "Time off trend is available in the pro plan")));
};
var LIMIT = 10;
var offsets = 0;
var LeaveListing = function LeaveListing(props) {
  var _leaveListCountData$l, _leaveListCountData$l2, _leaveListCountData$l3, _leaveListCountData$l4;
  var organisationId = props.organisationId,
    userId = props.userId,
    organisationSettings = props.organisationSettings,
    activeTab = props.activeTab,
    setActiveTab = props.setActiveTab,
    role = props.role,
    currentYear = props.currentYear,
    workingDays = props.workingDays,
    organisationBilling = props.organisationBilling,
    last14Days = props.last14Days,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    leaveSettingData = props.leaveSettingData,
    leaveSettingLoading = props.leaveSettingLoading;

  //loadmore
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isAllLoaded = _React$useState10[0],
    setIsAllLoaded = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isLoadingMore = _React$useState12[0],
    setIsLoadingMore = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isLoadMoreButton = _React$useState14[0],
    setIsLoadMoreButton = _React$useState14[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    applyLeaveShow = _useState2[0],
    setApplyLeaveShow = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deleteLeaveData = _useState4[0],
    setDeleteLeaveData = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    applyPermissionShow = _useState6[0],
    setApplyPermissionShow = _useState6[1];
  var _React$useState15 = React.useState({
      label: "All Leaves",
      value: null
    }),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    leaveTypeParameterCheck = _React$useState16[0],
    setLeaveTypeParameterCheck = _React$useState16[1];
  var _React$useState17 = React.useState(null),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    leaveFilterStartDate = _React$useState18[0],
    setLeaveFilterStartDate = _React$useState18[1];
  var _React$useState19 = React.useState(null),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    leaveFilterEndDate = _React$useState20[0],
    setLeaveFilterEndDate = _React$useState20[1];
  var _React$useState21 = React.useState(null),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    leaveStartDateMonthFilter = _React$useState22[0],
    setLeaveStartDate = _React$useState22[1];
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    leaveEndDateMonthFilter = _React$useState24[0],
    setLeaveEndDate = _React$useState24[1];
  function convertOrganisationTimezone(sD, eD, tz) {
    var currentSystemTimezone = moment.tz.guess();
    var startTime = moment(sD).tz(tz).format("YYYY-MM-DD HH:mm:ss");
    var endTime = moment(eD).tz(tz).format("YYYY-MM-DD HH:mm:ss");
    var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
    var zoneoffset = moment.tz(tz).utcOffset();
    if (zoneoffset !== currentSystemOffset) {
      var zoneoffsetTemp = Math.abs(zoneoffset);
      var currentSystemOffsetTemp = Math.abs(currentSystemOffset);
      if (zoneoffset > 0) {
        zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
      } else {
        zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
      }
    }
    var startTimeFullFormat = moment(startTime).tz(currentSystemTimezone).startOf("month").format("YYYY-MM-DD HH:mm:ss");
    var endTimeFullFormat = moment(endTime).tz(currentSystemTimezone).endOf("month").format("YYYY-MM-DD HH:mm:ss");
    if (zoneoffset >= 0) {
      startTimeFullFormat = moment(startTime).startOf("month").format("YYYY-MM-DD HH:mm:ss");
      endTimeFullFormat = moment(endTime).endOf("month").format("YYYY-MM-DD HH:mm:ss");
      if (zoneoffset !== currentSystemOffset && zoneoffset < currentSystemOffset) {
        startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("month").format("YYYY-MM-DD HH:mm:ss");
        endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("month").format("YYYY-MM-DD HH:mm:ss");
      } else if (zoneoffset > currentSystemOffset) {
        startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("month").format("YYYY-MM-DD HH:mm:ss");
        endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("month").format("YYYY-MM-DD HH:mm:ss");
      }
    } else {
      zoneoffset = Math.abs(zoneoffset);
      startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("month").format("YYYY-MM-DD HH:mm:ss");
      endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("month").format("YYYY-MM-DD HH:mm:ss");
    }
    return {
      startTimeFullFormat: startTimeFullFormat,
      endTimeFullFormat: endTimeFullFormat
    };
  }
  React.useEffect(function () {
    if (leaveFilterStartDate != null || leaveFilterEndDate != null) {
      var _convertOrganisationT = convertOrganisationTimezone(leaveFilterStartDate, leaveFilterEndDate !== null && leaveFilterEndDate !== void 0 ? leaveFilterEndDate : leaveFilterStartDate, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone),
        startTimeFullFormat = _convertOrganisationT.startTimeFullFormat,
        endTimeFullFormat = _convertOrganisationT.endTimeFullFormat;
      setLeaveStartDate(startTimeFullFormat);
      setLeaveEndDate(endTimeFullFormat);
    } else {
      setLeaveStartDate(null);
      setLeaveEndDate(null);
    }
  }, [leaveFilterStartDate, leaveFilterEndDate]);
  var _useQuery3 = useQuery(LEAVE_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: userId,
        filter: activeTab,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
        freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
        leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
        startTime: leaveStartDateMonthFilter,
        endTime: leaveEndDateMonthFilter
      },
      skip: !organisationId
    }),
    leaveListData = _useQuery3.data,
    leaveListError = _useQuery3.error,
    leaveListLoading = _useQuery3.loading,
    listRefetch = _useQuery3.refetch,
    fetchMore = _useQuery3.fetchMore;
  var _useQuery4 = useQuery(LEAVE_LIST_COUNT_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: userId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
        freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
        leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
        startTime: leaveStartDateMonthFilter,
        endTime: leaveEndDateMonthFilter
      },
      skip: !organisationId
    }),
    leaveListCountData = _useQuery4.data,
    leaveListCountError = _useQuery4.error,
    leaveListCountLoading = _useQuery4.loading,
    countRefetch = _useQuery4.refetch;
  var _useQuery5 = useQuery(LIST_PERMISSION_TYPE_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userId: userId
      },
      skip: !organisationId
    }),
    permissionTypeListData = _useQuery5.data,
    permissionTypeListError = _useQuery5.error,
    permissionTypeListLoading = _useQuery5.loading,
    permissionTypeRefetch = _useQuery5.refetch;
  React.useEffect(function () {
    offsets = 0;
    setIsAllLoaded(false);
    setIsLoadingMore(false);
    listRefetch === null || listRefetch === void 0 ? void 0 : listRefetch();
    countRefetch === null || countRefetch === void 0 ? void 0 : countRefetch();
    permissionTypeRefetch();
  }, [activeTab]);
  React.useEffect(function () {
    offsets = 0;
    setIsAllLoaded(false);
    setIsLoadingMore(false);
    listRefetch === null || listRefetch === void 0 ? void 0 : listRefetch();
    countRefetch === null || countRefetch === void 0 ? void 0 : countRefetch();
    permissionTypeRefetch();
  }, [leaveTypeParameterCheck]);
  React.useEffect(function () {
    offsets = 0;
    setIsAllLoaded(false);
    setIsLoadingMore(false);
    listRefetch === null || listRefetch === void 0 ? void 0 : listRefetch();
    countRefetch === null || countRefetch === void 0 ? void 0 : countRefetch();
    permissionTypeRefetch();
  }, [leaveStartDateMonthFilter, leaveEndDateMonthFilter]);
  var handleTabSelect = function handleTabSelect(key) {
    setActiveTab(key);
  };
  var handleLoadMore = function handleLoadMore() {
    if (leaveListLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$leav, _fetchMoreResult$leav2;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$leav = fetchMoreResult.leaveList) === null || _fetchMoreResult$leav === void 0 ? void 0 : _fetchMoreResult$leav.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$leav2 = fetchMoreResult.leaveList) === null || _fetchMoreResult$leav2 === void 0 ? void 0 : _fetchMoreResult$leav2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          leaveList: [].concat(_toConsumableArray(prev.leaveList), _toConsumableArray(fetchMoreResult.leaveList))
        });
      }
    });
  };
  var handleApplyLeaveShow = function handleApplyLeaveShow(data) {
    setApplyLeaveShow(data);
  };
  var handleApplyLeaveClose = function handleApplyLeaveClose() {
    return setApplyLeaveShow(false);
  };
  var handleApplyPermissionShow = function handleApplyPermissionShow(data) {
    setApplyPermissionShow(data);
  };
  var handleApplyPermissionClose = function handleApplyPermissionClose() {
    return setApplyPermissionShow(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-whole-div"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "upcoming",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    },
    className: "leave-listing-tab-header-tab"
  }, /*#__PURE__*/React.createElement(Tab
  // eventKey="home"
  , {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Applied Leave Details"),
    className: "leave-listing-tab-header-tab-text"
  }), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "upcoming",
    title: /*#__PURE__*/React.createElement("span", null, "Upcoming", " ", (leaveListCountData === null || leaveListCountData === void 0 ? void 0 : (_leaveListCountData$l = leaveListCountData.leaveListCount) === null || _leaveListCountData$l === void 0 ? void 0 : _leaveListCountData$l.upcomingCount) != 0 && !leaveListCountLoading && !leaveListCountError ? "(".concat(leaveListCountData === null || leaveListCountData === void 0 ? void 0 : (_leaveListCountData$l2 = leaveListCountData.leaveListCount) === null || _leaveListCountData$l2 === void 0 ? void 0 : _leaveListCountData$l2.upcomingCount, ")") : leaveListCountLoading ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "")
  }, /*#__PURE__*/React.createElement(TabContent, {
    activeTab: activeTab,
    leaveListData: leaveListData,
    handleLoadMore: handleLoadMore,
    setIsAllLoaded: setIsAllLoaded,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    handleApplyLeaveShow: handleApplyLeaveShow,
    applyLeaveShow: applyLeaveShow,
    setApplyLeaveShow: setApplyLeaveShow,
    userId: userId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    deleteLeaveData: deleteLeaveData,
    setDeleteLeaveData: setDeleteLeaveData,
    currentYear: currentYear,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling,
    last14Days: last14Days,
    permissionTypeListData: permissionTypeListData,
    handleApplyPermissionShow: handleApplyPermissionShow,
    leaveBalanceStartDate: leaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    leaveTypeParameterCheck: leaveTypeParameterCheck,
    setLeaveTypeParameterCheck: setLeaveTypeParameterCheck,
    leaveSettingData: leaveSettingData,
    leaveSettingLoading: leaveSettingLoading,
    leaveListLoading: leaveListLoading,
    leaveListError: leaveListError,
    leaveFilterStartDate: leaveFilterStartDate,
    setLeaveFilterStartDate: setLeaveFilterStartDate,
    leaveFilterEndDate: leaveFilterEndDate,
    setLeaveFilterEndDate: setLeaveFilterEndDate,
    organisationSettings: organisationSettings,
    leaveStartDateMonthFilter: leaveStartDateMonthFilter,
    leaveEndDateMonthFilter: leaveEndDateMonthFilter,
    setLeaveStartDate: setLeaveStartDate,
    setLeaveEndDate: setLeaveEndDate
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "past",
    title: /*#__PURE__*/React.createElement("span", null, "Past", " ", (leaveListCountData === null || leaveListCountData === void 0 ? void 0 : (_leaveListCountData$l3 = leaveListCountData.leaveListCount) === null || _leaveListCountData$l3 === void 0 ? void 0 : _leaveListCountData$l3.pastCount) != 0 && !leaveListCountLoading && !leaveListCountError ? "(".concat(leaveListCountData === null || leaveListCountData === void 0 ? void 0 : (_leaveListCountData$l4 = leaveListCountData.leaveListCount) === null || _leaveListCountData$l4 === void 0 ? void 0 : _leaveListCountData$l4.pastCount, ")") : leaveListCountLoading ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "")
  }, /*#__PURE__*/React.createElement(TabContent, {
    activeTab: activeTab,
    leaveListData: leaveListData,
    handleLoadMore: handleLoadMore,
    setIsAllLoaded: setIsAllLoaded,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    handleApplyLeaveShow: handleApplyLeaveShow,
    applyLeaveShow: applyLeaveShow,
    setApplyLeaveShow: setApplyLeaveShow,
    userId: userId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    deleteLeaveData: deleteLeaveData,
    setDeleteLeaveData: setDeleteLeaveData,
    currentYear: currentYear,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling,
    last14Days: last14Days,
    handleApplyPermissionShow: handleApplyPermissionShow,
    permissionTypeListData: permissionTypeListData,
    leaveBalanceStartDate: leaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    leaveTypeParameterCheck: leaveTypeParameterCheck,
    setLeaveTypeParameterCheck: setLeaveTypeParameterCheck,
    leaveSettingData: leaveSettingData,
    leaveSettingLoading: leaveSettingLoading,
    leaveListLoading: leaveListLoading,
    leaveListError: leaveListError,
    leaveFilterStartDate: leaveFilterStartDate,
    setLeaveFilterStartDate: setLeaveFilterStartDate,
    leaveFilterEndDate: leaveFilterEndDate,
    setLeaveFilterEndDate: setLeaveFilterEndDate,
    organisationSettings: organisationSettings,
    leaveStartDateMonthFilter: leaveStartDateMonthFilter,
    leaveEndDateMonthFilter: leaveEndDateMonthFilter,
    setLeaveStartDate: setLeaveStartDate,
    setLeaveEndDate: setLeaveEndDate
  })), permissionTypeListData !== null && permissionTypeListData !== void 0 && permissionTypeListData.permissionTypeList.length ? /*#__PURE__*/React.createElement(Tab, {
    title: /*#__PURE__*/React.createElement(Button, {
      variant: "info",
      className: "rounded-pill px-3 page-content-wrapper-menu-add-user",
      size: "sm",
      onClick: function onClick() {
        return handleApplyPermissionShow({
          type: "add"
        });
      }
    }, /*#__PURE__*/React.createElement(HiPlus, {
      className: "apply-leave-button-icon"
    }), " Apply Short Leave")
  }, " ") : null, /*#__PURE__*/React.createElement(Tab
  // eventKey="add-leave-button"
  , {
    title: /*#__PURE__*/React.createElement(Button, {
      variant: "info",
      className: "rounded-pill px-3 page-content-wrapper-menu-add-user",
      size: "sm",
      onClick: function onClick() {
        return handleApplyLeaveShow({
          type: "add"
        });
      }
    }, /*#__PURE__*/React.createElement(HiPlus, {
      className: "apply-leave-button-icon"
    }), " Apply Leave")
  }, " "))), /*#__PURE__*/React.createElement(ApplyLeaveModal, {
    applyLeaveShow: applyLeaveShow,
    handleApplyLeaveClose: handleApplyLeaveClose,
    organisationId: organisationId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    userId: userId,
    activeTab: activeTab,
    role: role,
    workingDays: workingDays,
    currentYear: currentYear,
    last14Days: last14Days,
    setApplyLeaveShow: setApplyLeaveShow,
    organisationBilling: organisationBilling,
    leaveBalanceStartDate: leaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    leaveTypeParameterCheck: leaveTypeParameterCheck,
    leaveStartDateMonthFilter: leaveStartDateMonthFilter,
    leaveEndDateMonthFilter: leaveEndDateMonthFilter
  }), /*#__PURE__*/React.createElement(ApplyPermissionModal, {
    applyPermissionShow: applyPermissionShow,
    handleApplyPermissionClose: handleApplyPermissionClose,
    organisationId: organisationId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    userId: userId,
    activeTab: activeTab,
    role: role,
    workingDays: workingDays,
    currentYear: currentYear,
    last14Days: last14Days,
    setApplyPermissionShow: setApplyPermissionShow,
    organisationBilling: organisationBilling,
    leaveBalanceStartDate: leaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    leaveTypeParameterCheck: leaveTypeParameterCheck,
    leaveStartDateMonthFilter: leaveStartDateMonthFilter,
    leaveEndDateMonthFilter: leaveEndDateMonthFilter
  }));
};
export function convertOrganisationTimezones(sD, loopingCount, tz) {
  var startTime = moment(sD).format("YYYY-MM-DD HH:mm:ss");
  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(tz).utcOffset();
  if (zoneoffset !== currentSystemOffset) {
    var zoneoffsetTemp = Math.abs(zoneoffset);
    var currentSystemOffsetTemp = Math.abs(currentSystemOffset);
    if (zoneoffset > 0) {
      zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
    } else {
      zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
    }
  }
  if (zoneoffset >= 0) {
    startTime = moment(startTime).toDate();
    if (zoneoffset !== currentSystemOffset) {
      startTime = moment(startTime).add(zoneoffset, "minutes").toDate();
    }
  } else {
    zoneoffset = Math.abs(zoneoffset);
    startTime = moment(startTime).add(zoneoffset, "minutes").toDate();
  }
  var startTimeFullFormat = moment(startTime).add(loopingCount, "days").format("DD MMM, YYYY");
  return startTimeFullFormat;
}
function LeaveTimeFilter(props) {
  var onClose = props.onClose,
    leaveFilterStartDate = props.leaveFilterStartDate,
    setLeaveFilterStartDate = props.setLeaveFilterStartDate,
    leaveFilterEndDate = props.leaveFilterEndDate,
    setLeaveFilterEndDate = props.setLeaveFilterEndDate,
    organisationBilling = props.organisationBilling;
  var handleDateChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLeaveFilterStartDate(e[0]);
            setLeaveFilterEndDate(e[1]);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleDateChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var datePickerMinDate = stringToArrayOutput("Free Plan Days");
  var datepickerPermissionForPast = stringToArrayOutput("Today");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-page-wrapper-form-date-picker-filter-filter"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    selected: leaveFilterStartDate,
    onChange: function onChange(e) {
      handleDateChange(e);
      //handleFilterChange(e);
    },
    isClearable: true,
    startDate: leaveFilterStartDate,
    endDate: leaveFilterEndDate,
    selectsRange: true,
    showMonthYearPicker: true
    // minDate={
    //   permissionSettingData?.leaveSettingsPermission?.leavePermissions == "false"
    //     ? datepickerPermissionForPast[0]
    //     : organisationBilling?.planName == "free" || organisationBilling?.planStatus == "stopped"
    //     ? datePickerMinDate[0]
    //     : ""
    // }
  }))));
}
var TabContent = function TabContent(props) {
  var _leaveListData$leaveL, _leaveListData$leaveL2, _leaveSettingData$lea3, _leaveListData$leaveL3, _leaveListData$leaveL4;
  var activeTab = props.activeTab,
    leaveListData = props.leaveListData,
    setIsAllLoaded = props.setIsAllLoaded,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    handleLoadMore = props.handleLoadMore,
    handleApplyLeaveShow = props.handleApplyLeaveShow,
    applyLeaveShow = props.applyLeaveShow,
    setApplyLeaveShow = props.setApplyLeaveShow,
    userId = props.userId,
    timeZone = props.timeZone,
    organisationId = props.organisationId,
    deleteLeaveData = props.deleteLeaveData,
    setDeleteLeaveData = props.setDeleteLeaveData,
    currentYear = props.currentYear,
    planName = props.planName,
    organisationBilling = props.organisationBilling,
    last14Days = props.last14Days,
    handleApplyPermissionShow = props.handleApplyPermissionShow,
    permissionTypeListData = props.permissionTypeListData,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    leaveTypeParameterCheck = props.leaveTypeParameterCheck,
    setLeaveTypeParameterCheck = props.setLeaveTypeParameterCheck,
    leaveSettingData = props.leaveSettingData,
    leaveSettingLoading = props.leaveSettingLoading,
    leaveListLoading = props.leaveListLoading,
    leaveListError = props.leaveListError,
    leaveFilterStartDate = props.leaveFilterStartDate,
    setLeaveFilterStartDate = props.setLeaveFilterStartDate,
    leaveFilterEndDate = props.leaveFilterEndDate,
    setLeaveFilterEndDate = props.setLeaveFilterEndDate,
    organisationSettings = props.organisationSettings,
    leaveStartDateMonthFilter = props.leaveStartDateMonthFilter,
    leaveEndDateMonthFilter = props.leaveEndDateMonthFilter,
    setLeaveStartDate = props.setLeaveStartDate,
    setLeaveEndDate = props.setLeaveEndDate;
  if ((leaveListData === null || leaveListData === void 0 ? void 0 : (_leaveListData$leaveL = leaveListData.leaveList) === null || _leaveListData$leaveL === void 0 ? void 0 : _leaveListData$leaveL.length) !== 0 && (leaveListData === null || leaveListData === void 0 ? void 0 : (_leaveListData$leaveL2 = leaveListData.leaveList) === null || _leaveListData$leaveL2 === void 0 ? void 0 : _leaveListData$leaveL2.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(timeZone).utcOffset();
  //console.log({ zoneoffset, currentSystemOffset });

  var leaveList = [{
    label: "All Leaves",
    value: null
  }];
  if (permissionTypeListData !== null && permissionTypeListData !== void 0 && permissionTypeListData.permissionTypeList.length) {
    leaveList.push({
      label: "Short Leaves",
      value: "permission"
    });
  }
  leaveSettingData === null || leaveSettingData === void 0 ? void 0 : (_leaveSettingData$lea3 = leaveSettingData.leaveTypeCardLists) === null || _leaveSettingData$lea3 === void 0 ? void 0 : _leaveSettingData$lea3.map(function (item) {
    var leaveTypeName = item.leaveTypeName,
      leaveTypeId = item.leaveTypeId;
    return leaveList.push({
      label: leaveTypeName,
      value: leaveTypeId
    });
  });
  var hideOverlay = function hideOverlay() {
    var _document2, _document2$body, _document2$body$click;
    (_document2 = document) === null || _document2 === void 0 ? void 0 : (_document2$body = _document2.body) === null || _document2$body === void 0 ? void 0 : (_document2$body$click = _document2$body.click) === null || _document2$body$click === void 0 ? void 0 : _document2$body$click.call(_document2$body);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-filter-new-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: leaveTypeParameterCheck,
    onChange: function onChange(e) {
      return setLeaveTypeParameterCheck(e);
    },
    options: leaveList,
    className: "leave-listing-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User",
    placeholder: "Select Employee",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    },
    isLoading: leaveSettingLoading
  })), /*#__PURE__*/React.createElement("div", {
    className: "leave-history-date-picker"
  }, " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(LeaveTimeFilter, {
      onClose: hideOverlay,
      leaveFilterStartDate: leaveFilterStartDate,
      setLeaveFilterStartDate: setLeaveFilterStartDate,
      leaveFilterEndDate: leaveFilterEndDate,
      setLeaveFilterEndDate: setLeaveFilterEndDate,
      organisationBilling: organisationBilling
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter",
    className: "leave-listing-filter-date-picker-filter-date leave-listing-filter-div-field-input"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-filter-date-picker-filter-date-label"
  }, /*#__PURE__*/React.createElement(MdDateRange, {
    className: "leave-listing-filter-date-picker-filter-date-icon"
  }), leaveFilterStartDate && leaveFilterEndDate ? /*#__PURE__*/React.createElement("p", {
    className: "leave-listing-filter-date-picker-filter-date-text"
  }, arrayToStringOutputFilter([Number(leaveFilterStartDate), Number(leaveFilterEndDate)], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) : leaveFilterStartDate ? /*#__PURE__*/React.createElement("p", {
    className: "leave-listing-filter-date-picker-filter-date-text"
  }, arrayToStringOutputFilter([Number(leaveFilterStartDate), Number(leaveFilterStartDate)], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) : /*#__PURE__*/React.createElement("p", {
    className: "leave-listing-filter-date-picker-filter-date-text"
  }, "Select Month")), leaveFilterStartDate || leaveFilterEndDate ? /*#__PURE__*/React.createElement(RiCloseCircleFill, {
    className: "leave-listing-filter-date-picker-filter-date-clear-icon",
    onClick: function onClick(e) {
      hideOverlay();
      setLeaveFilterStartDate(null);
      setLeaveFilterEndDate(null);
      setLeaveStartDate(null);
      setLeaveEndDate(null);
    }
  }) : null))))), leaveListLoading ? /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-loader"
  }, /*#__PURE__*/React.createElement(Loader, null)) : leaveListError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : (leaveListData === null || leaveListData === void 0 ? void 0 : leaveListData.leaveList.length) !== 0 ? /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-list-whole"
  }, leaveListData === null || leaveListData === void 0 ? void 0 : (_leaveListData$leaveL3 = leaveListData.leaveList) === null || _leaveListData$leaveL3 === void 0 ? void 0 : _leaveListData$leaveL3.map(function (list, index) {
    var leaveId = list.leaveId,
      leaveType = list.leaveType,
      leaveStartDate = list.leaveStartDate,
      leaveEndDate = list.leaveEndDate,
      leaveDays = list.leaveDays,
      appliedStatus = list.appliedStatus,
      leaveReason = list.leaveReason,
      appliedAt = list.appliedAt,
      dateDetails = list.dateDetails,
      statusModifyDisplayName = list.statusModifyDisplayName,
      leaveRejectReason = list.leaveRejectReason,
      leaveTypeArchive = list.leaveTypeArchive,
      leaveTypeDeleted = list.leaveTypeDeleted,
      leaveStartDateFormat = list.leaveStartDateFormat,
      leaveEndDateFormat = list.leaveEndDateFormat,
      attendanceType = list.attendanceType,
      permissionTypeId = list.permissionTypeId,
      permissionStartTime = list.permissionStartTime,
      permissionEndTime = list.permissionEndTime,
      editStartTime = list.editStartTime,
      editEndTime = list.editEndTime,
      leaveAttachments = list.leaveAttachments;
    if (deleteLeaveData.length > 0 && deleteLeaveData.includes(leaveId)) {
      return;
    }
    var startValueFormate = moment(Number(leaveStartDate)).format("DD MMM, YYYY");
    var endValueFormate = leaveEndDate ? moment(Number(leaveEndDate)).format("DD MMM, YYYY") : null;
    if (zoneoffset !== currentSystemOffset) {
      startValueFormate = convertOrganisationTimezones(moment(Number(leaveStartDate)).format("YYYY-MM-DD HH:mm:ss"), 0, timeZone);
      if (leaveEndDate) {
        endValueFormate = convertOrganisationTimezones(moment(Number(leaveEndDate)).format("YYYY-MM-DD HH:mm:ss"), 0, timeZone);
      }
    }

    // console.log({ dateDetails });
    // console.log("\n\n\n\n");

    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "leave-listing-tab-tab-Content-list"
    }, attendanceType == "permission" ? /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-date"
    }, leaveStartDateFormat, " ", /*#__PURE__*/React.createElement("span", {
      className: "short-leave-history-time"
    }, "(", moment.unix(permissionStartTime / 1000).format("hh:mm A"), " -", " ", moment.unix(permissionEndTime / 1000).format("hh:mm A"), ")")) : /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-date"
    }, leaveEndDateFormat ? "".concat(leaveStartDateFormat, " - ").concat(leaveEndDateFormat) : leaveStartDateFormat), /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-dates-count"
    }, /*#__PURE__*/React.createElement("span", {
      className: "leave-listing-tab-tab-Content-list-dates-count-span"
    }, " ", leaveDays, " ", attendanceType == "permission" ? "" : leaveDays > 1 ? "Days" : "Day"), attendanceType != "permission" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "view-leave-balanace-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", {
        className: "view-leave-balanace-count-tooltip-user-content"
      }, dateDetails.map(function (dateValue) {
        return /*#__PURE__*/React.createElement("div", {
          className: "view-leave-balanace-count-tooltip-user-content-div"
        }, /*#__PURE__*/React.createElement("span", null, dateValue.dateFormatTooltip, ": "), /*#__PURE__*/React.createElement("span", {
          className: "view-leave-balanace-tooltip-start-span"
        }, dateValue.dayType == "full-day" ? "Full Day" : dateValue.dayType == "half-day-first-half" || dateValue.dayType == "non-working-day" && dateValue.nonWorkingDayLeaveSession == "half-day-first-half" ? "Half day - 1st Half" : dateValue.dayType == "half-day-second-half" || dateValue.dayType == "non-working-day" && dateValue.nonWorkingDayLeaveSession == "half-day-second-half" ? "Half day - 2nd Half" : dateValue.dayType == "non-working-day" && (dateValue.nonWorkingDayLeaveSession == "full-day" || dateValue.nonWorkingDayLeaveSession == null) ? "Non Working Day" : null));
      })))
    }, /*#__PURE__*/React.createElement("span", {
      className: "leave-listing-tab-tab-Content-list-dates-count-span-icon"
    }, /*#__PURE__*/React.createElement(MdInfoOutline, null))) : null), /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-type"
    }, attendanceType == "permission" ? /*#__PURE__*/React.createElement(Badge, {
      variant: attendanceType == "permission" ? "light" : "light",
      className: classNames("leave-listing-tab-tab-Content-list-status-badge-permission")
    }, "Short leave") : leaveType.replace(/-/g, " "), " "), /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-status"
    }, appliedStatus == "pending" ? /*#__PURE__*/React.createElement(Badge, {
      variant: appliedStatus == "approved" ? "success" : appliedStatus == "rejected" ? "danger" : "warning",
      className: classNames("leave-listing-tab-tab-Content-list-status-badge", {
        "leave-listing-tab-tab-Content-list-status-badge-approved-color": appliedStatus == "approved"
      }, {
        "leave-listing-tab-tab-Content-list-status-badge-pending-color": appliedStatus == "pending"
      }, {
        "leave-listing-tab-tab-Content-list-status-badge-rejected-color": appliedStatus == "rejected"
      })
    }, appliedStatus == "pending" ? "Approval Pending" : appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1)) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1), " ", statusModifyDisplayName !== null ? "by ".concat(statusModifyDisplayName) : "", appliedStatus == "rejected" && leaveRejectReason ? /*#__PURE__*/React.createElement("div", null, "Rejection Reason : ", decodeHtmlEntities(leaveRejectReason)) : null))
    }, /*#__PURE__*/React.createElement(Badge, {
      variant: appliedStatus == "approved" ? "success" : appliedStatus == "rejected" ? "danger" : "warning",
      className: classNames("leave-listing-tab-tab-Content-list-status-badge", {
        "leave-listing-tab-tab-Content-list-status-badge-approved-color": appliedStatus == "approved"
      }, {
        "leave-listing-tab-tab-Content-list-status-badge-pending-color": appliedStatus == "pending"
      }, {
        "leave-listing-tab-tab-Content-list-status-badge-rejected-color": appliedStatus == "rejected"
      })
    }, appliedStatus == "pending" ? "Approval Pending" : appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1), statusModifyDisplayName !== null ? " by ".concat(statusModifyDisplayName) : ""))), /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-type-div-text"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, decodeHtmlEntities(leaveReason)))
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-dates-text"
    }, " ", decodeHtmlEntities(leaveReason)))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" ? /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-attachments"
    }, leaveAttachments && leaveAttachments.length > 0 ? leaveAttachments.map(function (attachment) {
      return /*#__PURE__*/React.createElement("a", {
        key: attachment.attachmentId,
        href: attachment.attachmentUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "leave-listing-attachment-name"
      }, /*#__PURE__*/React.createElement(FaRegFilePdf, {
        className: "leave-listing-attachment-icon"
      }), /*#__PURE__*/React.createElement("u", null, "View"));
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "leave-listing-tab-tab-Content-list-edits"
    }, /*#__PURE__*/React.createElement(ActionMenuWithButtons, {
      onEditLeave: function onEditLeave() {
        return handleApplyLeaveShow({
          leaveId: leaveId,
          leaveType: leaveType,
          leaveStartDate: leaveStartDate,
          leaveEndDate: leaveEndDate,
          leaveDays: leaveDays,
          appliedStatus: appliedStatus,
          leaveReason: decodeHtmlEntities(leaveReason),
          appliedAt: appliedAt,
          dateDetails: dateDetails,
          type: "edit",
          leaveStartDateFormat: leaveStartDateFormat,
          leaveEndDateFormat: leaveEndDateFormat,
          editStartTime: editStartTime,
          editEndTime: editEndTime,
          userId: userId,
          leaveAttachments: leaveAttachments
        });
      },
      appliedStatus: appliedStatus,
      userId: userId,
      dateDetails: dateDetails,
      leaveId: leaveId,
      organisationId: organisationId,
      timeZone: timeZone,
      currentYear: currentYear,
      setDeleteLeaveData: setDeleteLeaveData,
      activeTab: activeTab,
      deleteLeaveData: deleteLeaveData,
      organisationBilling: organisationBilling,
      last14Days: last14Days,
      leaveTypeArchive: leaveTypeArchive,
      leaveTypeDeleted: leaveTypeDeleted,
      attendanceType: attendanceType,
      onEditShortLeave: function onEditShortLeave() {
        return handleApplyPermissionShow({
          permissionId: leaveId,
          permissionTypeId: permissionTypeId,
          permissionDate: leaveStartDate,
          leaveDays: leaveDays,
          appliedStatus: appliedStatus,
          permissionRemark: leaveReason,
          appliedAt: appliedAt,
          dateDetails: dateDetails,
          type: "edit",
          permissionStartTime: permissionStartTime,
          permissionEndTime: permissionEndTime
        });
      },
      permissionTypeListData: permissionTypeListData,
      leaveBalanceStartDate: leaveBalanceStartDate,
      leaveBalanceEndDate: leaveBalanceEndDate,
      leaveTypeParameterCheck: leaveTypeParameterCheck,
      leaveStartDateMonthFilter: leaveStartDateMonthFilter,
      leaveEndDateMonthFilter: leaveEndDateMonthFilter
    })));
  })) : activeTab == "upcoming" ? /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext"
  }, "You have no upcoming leaves") : planName == "free" && activeTab == "past" ? /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext"
  }, "There is no data to show.", /*#__PURE__*/React.createElement("p", null, "On the free plan, you can access the last 14 days of data only. Upgrade to the Pro plan to get the historical data.")) : activeTab == "past" ? /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext"
  }, "You have no past leaves") : /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext"
  }, "You have no leaves to show"), leaveListData !== null && leaveListData !== void 0 && (_leaveListData$leaveL4 = leaveListData.leaveList) !== null && _leaveListData$leaveL4 !== void 0 && _leaveListData$leaveL4.length ? /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : activeTab == "upcoming" ? /*#__PURE__*/React.createElement("div", {
    className: "leave-list-text-load-more-button project-management-miled-color"
  }, "You have seen all the upcoming leaves") : planName == "free" && activeTab == "past" ? /*#__PURE__*/React.createElement("p", {
    className: "leave-list-text-load-more-button project-management-miled-color"
  }, "On the free plan, you can access the last 14 days of data only. Upgrade to the Pro plan to get the historical data.") : /*#__PURE__*/React.createElement("p", {
    className: "leave-list-text-load-more-button project-management-miled-color"
  }, "You have seen all the leave")) : null);
};
export var ActionMenuWithButtons = function ActionMenuWithButtons(props) {
  var onEditLeave = props.onEditLeave,
    appliedStatus = props.appliedStatus,
    userId = props.userId,
    dateDetails = props.dateDetails,
    leaveId = props.leaveId,
    organisationId = props.organisationId,
    timeZone = props.timeZone,
    currentYear = props.currentYear,
    setDeleteLeaveData = props.setDeleteLeaveData,
    activeTab = props.activeTab,
    deleteLeaveData = props.deleteLeaveData,
    organisationBilling = props.organisationBilling,
    last14Days = props.last14Days,
    leaveTypeArchive = props.leaveTypeArchive,
    leaveTypeDeleted = props.leaveTypeDeleted,
    attendanceType = props.attendanceType,
    onEditShortLeave = props.onEditShortLeave,
    permissionTypeListData = props.permissionTypeListData,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    leaveTypeParameterCheck = props.leaveTypeParameterCheck,
    leaveStartDateMonthFilter = props.leaveStartDateMonthFilter,
    leaveEndDateMonthFilter = props.leaveEndDateMonthFilter;
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    deleteModalShow = _useState8[0],
    setDeleteModalShow = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    deletePermissionModalShow = _useState10[0],
    setDeletePermissionModalShow = _useState10[1];
  var _React$useState25 = React.useState(""),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    deleteErrorText = _React$useState26[0],
    setDeleteErrorText = _React$useState26[1];
  var handleDeleteLeaveShow = function handleDeleteLeaveShow(data) {
    setDeleteModalShow(data);
  };
  var handleDeleteLeaveClose = function handleDeleteLeaveClose() {
    setDeleteModalShow(false);
    setDeleteErrorText("");
  };
  var handleDeletePermissionShow = function handleDeletePermissionShow(data) {
    setDeletePermissionModalShow(data);
  };
  var handleDeletePermissionClose = function handleDeletePermissionClose() {
    return setDeletePermissionModalShow(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, appliedStatus == "pending" ? /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-whole-div"
  }, attendanceType !== "permission" ? leaveTypeDeleted ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "This leave type is deleted, so you can't edit it.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Edit"))) : leaveTypeArchive == "archived" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Admin modified the leave type, so you can't edit it.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Edit"))) : /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div",
    onClick: attendanceType == "permission" ? onEditShortLeave : onEditLeave
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Edit")) : permissionTypeListData !== null && permissionTypeListData !== void 0 && permissionTypeListData.permissionTypeList.length ? /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div",
    onClick: attendanceType == "permission" ? onEditShortLeave : onEditLeave
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Edit")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Admin disable the short leave type, so you can't edit it.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Edit"))), attendanceType !== "permission" && leaveTypeDeleted ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "This leave type is deleted, so you can't delete it.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdDeleteForever, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Delete"))) : attendanceType !== "permission" && leaveTypeArchive == "archived" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Admin modified the leave type, so you can't delete it.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdDeleteForever, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Delete"))) : /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div",
    onClick: function onClick() {
      attendanceType == "permission" ? handleDeletePermissionShow({
        userId: userId,
        organisationId: organisationId,
        timeZone: timeZone,
        permissionId: leaveId
      }) : handleDeleteLeaveShow({
        userId: userId,
        organisationId: organisationId,
        timeZone: timeZone,
        dateDetails: dateDetails,
        leaveId: leaveId,
        attendanceType: attendanceType
      });
    }
  }, /*#__PURE__*/React.createElement(MdDeleteForever, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Delete"))) : /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-whole-div"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Approved or rejected ", attendanceType !== "permission" ? "leaves" : "short leaves", " can't be edited")
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Edit"))), /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Approved or rejected ", attendanceType !== "permission" ? "leaves" : "short leaves", " can't be deleted")
  }, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdDeleteForever, {
    className: "scheduled-reports-card-table-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "scheduled-reports-card-table-data-edit-text"
  }, "Delete")))), /*#__PURE__*/React.createElement(DeleteConfirmation, {
    show: deleteModalShow,
    handleDeleteLeaveClose: handleDeleteLeaveClose,
    currentYear: currentYear,
    setDeleteLeaveData: setDeleteLeaveData,
    activeTab: activeTab,
    deleteLeaveData: deleteLeaveData,
    organisationBilling: organisationBilling,
    last14Days: last14Days,
    leaveBalanceStartDate: leaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    setDeleteErrorText: setDeleteErrorText,
    deleteErrorText: deleteErrorText,
    leaveTypeParameterCheck: leaveTypeParameterCheck,
    leaveStartDateMonthFilter: leaveStartDateMonthFilter,
    leaveEndDateMonthFilter: leaveEndDateMonthFilter
  }), /*#__PURE__*/React.createElement(PermissionDeleteConfirmation, {
    show: deletePermissionModalShow,
    handleDeleteLeaveClose: handleDeletePermissionClose,
    currentYear: currentYear,
    setDeleteLeaveData: setDeleteLeaveData,
    activeTab: activeTab,
    deleteLeaveData: deleteLeaveData,
    organisationBilling: organisationBilling,
    last14Days: last14Days,
    leaveBalanceStartDate: leaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    leaveTypeParameterCheck: leaveTypeParameterCheck,
    leaveStartDateMonthFilter: leaveStartDateMonthFilter,
    leaveEndDateMonthFilter: leaveEndDateMonthFilter
  }));
};
var DeleteConfirmation = function DeleteConfirmation(props) {
  var show = props.show,
    handleDeleteLeaveClose = props.handleDeleteLeaveClose,
    currentYear = props.currentYear,
    setDeleteLeaveData = props.setDeleteLeaveData,
    activeTab = props.activeTab,
    deleteLeaveData = props.deleteLeaveData,
    organisationBilling = props.organisationBilling,
    last14Days = props.last14Days,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    setDeleteErrorText = props.setDeleteErrorText,
    deleteErrorText = props.deleteErrorText,
    leaveTypeParameterCheck = props.leaveTypeParameterCheck,
    leaveStartDateMonthFilter = props.leaveStartDateMonthFilter,
    leaveEndDateMonthFilter = props.leaveEndDateMonthFilter;
  if (show == null) {
    return null;
  }
  var userId = show.userId,
    dateDetails = show.dateDetails,
    leaveId = show.leaveId,
    organisationId = show.organisationId,
    timeZone = show.timeZone,
    attendanceType = show.attendanceType;
  var _useMutation = useMutation(DELETE_LEAVE_DETAILS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    deleteLeave = _useMutation2[0],
    deleting = _useMutation2[1].loading;
  var onDeleteSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var tempDateDetails, variables, response, deleteUser;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!deleting) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            tempDateDetails = dateDetails.reduce(function (acc, curr) {
              acc.push({
                dayType: curr.dayType,
                date: curr.date,
                nonWorkingDayLeaveSession: curr.nonWorkingDayLeaveSession,
                dateFormatEmail: curr.dateFormatEmail
              });
              return acc;
            }, []);
            variables = {
              userId: userId,
              dateDetails: tempDateDetails,
              leaveId: leaveId,
              organisationId: organisationId,
              timeZone: timeZone,
              freePlanStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
              attendanceType: attendanceType
            };
            _context2.next = 7;
            return deleteLeave({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_CHART_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  year: currentYear,
                  timeZone: timeZone
                }
              }, {
                query: LEAVE_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  filter: activeTab,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  timeZone: timeZone,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_TYPE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  startTime: Number(leaveBalanceStartDate),
                  endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate)
                }
              }]
              // //update: handleDeleteUser(organisationId, userId, teamId, role, search),
            });
          case 7:
            response = _context2.sent;
            if (response && response.data && response.data.deleteLeave !== "") {
              deleteUser = _toConsumableArray(deleteLeaveData);
              deleteUser.push(response.data.deleteLeave);
              setDeleteLeaveData(_toConsumableArray(deleteUser));
              handleDeleteLeaveClose();
              toast.success("Leave deleted successfully!");
            }
            _context2.next = 14;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](2);
            if (_context2.t0.message == "Some of your employees are changed the status") {
              setDeleteErrorText("Something went wrong, Pls refresh the page");
            }
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 11]]);
    }));
    return function onDeleteSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleDeleteLeaveClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Leave")), deleteErrorText !== "" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, deleteErrorText, " "))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, " ", /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to delete this leave?"), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "You can't undo this action once you deleted this leave.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return handleDeleteLeaveClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      onDeleteSubmit();
    },
    disabled: deleting
  }, deleting ? "Loading..." : "Delete"))));
};
var PermissionDeleteConfirmation = function PermissionDeleteConfirmation(props) {
  var show = props.show,
    handleDeleteLeaveClose = props.handleDeleteLeaveClose,
    currentYear = props.currentYear,
    setDeleteLeaveData = props.setDeleteLeaveData,
    activeTab = props.activeTab,
    deleteLeaveData = props.deleteLeaveData,
    organisationBilling = props.organisationBilling,
    last14Days = props.last14Days,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    leaveTypeParameterCheck = props.leaveTypeParameterCheck,
    leaveStartDateMonthFilter = props.leaveStartDateMonthFilter,
    leaveEndDateMonthFilter = props.leaveEndDateMonthFilter;
  if (show == null) {
    return null;
  }
  var userId = show.userId,
    permissionId = show.permissionId,
    organisationId = show.organisationId,
    timeZone = show.timeZone;
  var _useMutation3 = useMutation(DELETE_PERMISSION_DETAILS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    deletePermission = _useMutation4[0],
    deleting = _useMutation4[1].loading;
  var onDeleteSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var variables, response, deleteUser;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!deleting) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.prev = 2;
            variables = {
              userId: userId,
              permissionId: permissionId,
              organisationId: organisationId,
              timeZone: timeZone
            };
            _context3.next = 6;
            return deletePermission({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_CHART_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  year: currentYear,
                  timeZone: timeZone
                }
              }, {
                query: LEAVE_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  filter: activeTab,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  timeZone: timeZone,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_TYPE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  startTime: Number(leaveBalanceStartDate),
                  endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate)
                }
              }]
            });
          case 6:
            response = _context3.sent;
            if (response && response.data && response.data.deletePermission !== "") {
              deleteUser = _toConsumableArray(deleteLeaveData);
              deleteUser.push(response.data.deletePermission);
              setDeleteLeaveData(_toConsumableArray(deleteUser));
              handleDeleteLeaveClose();
              toast.success("Short leave deleted successfully!");
            }
            _context3.next = 12;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 10]]);
    }));
    return function onDeleteSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleDeleteLeaveClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Short Leave")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, " ", /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to delete this short leave?"), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "You can't undo this action once you deleted this short leave.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return handleDeleteLeaveClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      onDeleteSubmit();
    },
    disabled: deleting
  }, deleting ? "Loading..." : "Delete")));
};
var daysList = [{
  label: "Full day",
  value: "full-day"
}, {
  label: "Half day - 1st Half",
  value: "half-day-first-half"
}, {
  label: "Half day - 2nd Half",
  value: "half-day-second-half"
}];
var daysListFirstHalf = [{
  label: "Full day",
  value: "full-day",
  isDisabled: true
}, {
  label: "Half day - 1st Half",
  value: "half-day-first-half"
}, {
  label: "Half day - 2nd Half",
  value: "half-day-second-half",
  isDisabled: true
}];
var daysListSecondHalf = [{
  label: "Full day",
  value: "full-day",
  isDisabled: true
}, {
  label: "Half day - 1st Half",
  value: "half-day-first-half",
  isDisabled: true
}, {
  label: "Half day - 2nd Half",
  value: "half-day-second-half"
}];
var ApplyLeaveSchema = Yup.object().shape({
  user: Yup.string().trim().required("Required"),
  leaveType: Yup.string().trim().required("Required"),
  dates: Yup.array().min(1, "Required atleast 1 date").required("Required atleast 1 date"),
  reasonForLeave: Yup.string().trim().required("Required")
});
export function convertOrganisationTimezoneForfilterDate(sD, loopingCount, tz) {
  var currentSystemTimezone = moment.tz.guess();
  var startTime = moment(sD).tz(currentSystemTimezone).format("YYYY-MM-DD");
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(tz).utcOffset();
  if (zoneoffset !== currentSystemOffset) {
    var zoneoffsetTemp = Math.abs(zoneoffset);
    var currentSystemOffsetTemp = Math.abs(currentSystemOffset);
    if (zoneoffset > 0) {
      zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
    } else {
      zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
    }
  }
  if (zoneoffset >= 0) {
    startTime = moment(startTime).add(loopingCount, "days").format("YYYY-MM-DD HH:mm:ss");
    if (zoneoffset !== currentSystemOffset && zoneoffset < currentSystemOffset) {
      startTime = moment(startTime).add(zoneoffset, "minutes").add(loopingCount, "days").format("YYYY-MM-DD HH:mm:ss");
    }
  } else {
    zoneoffset = Math.abs(zoneoffset);
    startTime = moment(startTime).add(zoneoffset, "minutes").add(loopingCount, "days").format("YYYY-MM-DD HH:mm:ss");
  }

  //let startTimeFullFormat = moment(startTime).tz(currentSystemTimezone).add(loopingCount, "days").format("YYYY-MM-DD HH:mm:ss");

  return startTime;
}
export function ApplyLeaveModal(props) {
  var applyLeaveShow = props.applyLeaveShow,
    handleApplyLeaveClose = props.handleApplyLeaveClose,
    organisationId = props.organisationId,
    timeZone = props.timeZone,
    userId = props.userId,
    activeTab = props.activeTab,
    role = props.role,
    currentYear = props.currentYear,
    organisationBilling = props.organisationBilling,
    last14Days = props.last14Days,
    setApplyLeaveShow = props.setApplyLeaveShow,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    leaveTypeParameterCheck = props.leaveTypeParameterCheck,
    leaveStartDateMonthFilter = props.leaveStartDateMonthFilter,
    leaveEndDateMonthFilter = props.leaveEndDateMonthFilter;
  var workingDays = props.workingDays;
  if (applyLeaveShow == null) {
    return null;
  }
  var type = applyLeaveShow.type;
  var _React$useContext3 = React.useContext(FilterContext),
    teamId = _React$useContext3.teamId,
    leaveSettingsUser = _React$useContext3.leaveSettingsUser;
  var _React$useState27 = React.useState(workingDays),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    workingDaysState = _React$useState28[0],
    setWorkingDaysState = _React$useState28[1];
  var _React$useState29 = React.useState([]),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    userList = _React$useState30[0],
    setUserList = _React$useState30[1];
  var _React$useState31 = React.useState(userId),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    selectUserList = _React$useState32[0],
    setSelectUserList = _React$useState32[1];
  var _React$useState33 = React.useState([moment().format("YYYY"), moment().format("YYYY")]),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    holidayYear = _React$useState34[0],
    setHolidayYear = _React$useState34[1];
  var _useQuery6 = useQuery(HOLIDAY_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        holidayType: null,
        startYear: holidayYear[0],
        endYear: holidayYear[1],
        limit: null,
        offset: null
      }
    }),
    holidayListData = _useQuery6.data,
    holidayListError = _useQuery6.error,
    holidayListLoading = _useQuery6.loading,
    holidayListRefetch = _useQuery6.refetch;
  var _useQuery7 = useQuery(LEAVE_SETTINGS_APPROVED_LIST_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    permissionSettingLoading = _useQuery7.loading,
    permissionSettingData = _useQuery7.data,
    permissionSettingError = _useQuery7.error;
  var _useQuery8 = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery8.loading,
    userListData = _useQuery8.data,
    userListError = _useQuery8.error;
  var _useQuery9 = useQuery(USER_WORK_DAY_SETTINGS_QUERY_FOR_LEAVE, {
      variables: {
        organisationId: organisationId,
        userId: selectUserList,
        timeZone: timeZone
      }
    }),
    userWorkDayData = _useQuery9.data,
    userWorkDayError = _useQuery9.error,
    userWorkDayLoading = _useQuery9.loading,
    userWorkDayRefetch = _useQuery9.refetch;
  var _useState11 = useState(type == "add" ? [moment().toDate(), null] : [convertUTCToOrganisationTimezoneForOneDateLeave(Number(applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.editStartTime), timeZone), applyLeaveShow !== null && applyLeaveShow !== void 0 && applyLeaveShow.editEndTime ? convertUTCToOrganisationTimezoneForOneDateLeave(Number(applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.editEndTime), timeZone) : null]
    //[Number(applyLeaveShow?.editStartTime),Number(applyLeaveShow?.editEndTime)]
    ),
    _useState12 = _slicedToArray(_useState11, 2),
    dateRange = _useState12[0],
    setDateRange = _useState12[1];
  //console.log({applyLeaveShow});

  var _useQuery10 = useQuery(LIST_LEAVE_TYPE_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: timeZone,
        userId: selectUserList,
        startDate: dateRange && dateRange[0] ? moment(dateRange[0]).tz(timeZone).format("YYYY-MM-DD HH:mm:ss") : null,
        endDate: dateRange && dateRange[1] ? moment(dateRange[1]).tz(timeZone).format("YYYY-MM-DD HH:mm:ss") : null
      },
      skip: !organisationId
    }),
    leaveTypeListData = _useQuery10.data,
    leaveTypeListError = _useQuery10.error,
    leaveTypeListLoading = _useQuery10.loading,
    leaveTypeRefetch = _useQuery10.refetch;
  var apolloClient = useApolloClient();
  var _useMutation5 = useMutation(ADD_LEAVE_DETAILS_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    addLeaveDetails = _useMutation6[0],
    addLeaveDetailsLoading = _useMutation6[1].loading;
  var _useMutation7 = useMutation(EDIT_LEAVE_DETAILS_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    editLeaveDetails = _useMutation8[0],
    editLeaveDetailsLoading = _useMutation8[1].loading;
  var _useMutation9 = useMutation(ADD_LEAVE_ATTACHMENT_MUTATION),
    _useMutation10 = _slicedToArray(_useMutation9, 1),
    addLeaveAttachmentMutation = _useMutation10[0];
  var _useMutation11 = useMutation(DELETE_LEAVE_ATTACHMENT_MUTATION),
    _useMutation12 = _slicedToArray(_useMutation11, 1),
    deleteLeaveAttachmentMutation = _useMutation12[0];
  var _useState13 = useState(type == "edit" ?
    //arrayToStringOutput([Number(applyLeaveShow?.leaveStartDate), Number(applyLeaveShow?.leaveEndDate)], timeZone)
    applyLeaveShow !== null && applyLeaveShow !== void 0 && applyLeaveShow.leaveEndDateFormat ? "".concat(applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveStartDateFormat, " - ").concat(applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveEndDateFormat) : applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveStartDateFormat : null),
    _useState14 = _slicedToArray(_useState13, 2),
    filterData = _useState14[0],
    setFilterData = _useState14[1];
  var _useState15 = useState(applyLeaveShow !== null && applyLeaveShow !== void 0 && applyLeaveShow.leaveDays && type == "edit" ? applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveDays : null),
    _useState16 = _slicedToArray(_useState15, 2),
    oldTotalLeave = _useState16[0],
    setOldTotalLeave = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    nonWorkingErr = _useState18[0],
    setNonWorkingErr = _useState18[1];
  var _React$useState35 = React.useState(""),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    errorMsg = _React$useState36[0],
    setErrorMsg = _React$useState36[1];
  var formikRef = React.useRef(null);
  var _React$useState37 = React.useState(null),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    file = _React$useState38[0],
    setFile = _React$useState38[1];
  var fileInputRef = React.useRef(null);
  var _React$useState39 = React.useState(null),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    deletingAttachmentId = _React$useState40[0],
    setDeletingAttachmentId = _React$useState40[1];
  var _React$useState41 = React.useState(false),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    isUploading = _React$useState42[0],
    setIsUploading = _React$useState42[1];
  var _React$useState43 = React.useState(false),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    removeExistingAttachment = _React$useState44[0],
    setRemoveExistingAttachment = _React$useState44[1];
  var _React$useState45 = React.useState(false),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    attachmentScreen = _React$useState46[0],
    setAttachmentScreen = _React$useState46[1];
  var _React$useState47 = React.useState(null),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    pendingLeaveContext = _React$useState48[0],
    setPendingLeaveContext = _React$useState48[1];
  var _React$useState49 = React.useState(false),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    isDragOver = _React$useState50[0],
    setIsDragOver = _React$useState50[1];
  React.useEffect(function () {
    holidayListRefetch === null || holidayListRefetch === void 0 ? void 0 : holidayListRefetch();
  }, [applyLeaveShow]);
  React.useEffect(function () {
    setFile(null);
    setRemoveExistingAttachment(false);
    setAttachmentScreen(false);
    setPendingLeaveContext(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }, [applyLeaveShow]);
  React.useEffect(function () {
    leaveTypeRefetch === null || leaveTypeRefetch === void 0 ? void 0 : leaveTypeRefetch();
    userWorkDayRefetch === null || userWorkDayRefetch === void 0 ? void 0 : userWorkDayRefetch();
    holidayListRefetch === null || holidayListRefetch === void 0 ? void 0 : holidayListRefetch();
  }, [selectUserList]);
  React.useEffect(function () {
    var _formikRef$current, _formikRef$current2, _formikRef$current3;
    if (type === "edit") return; // ⛔ don't reset for edit mode

    // RESET only when adding new leave
    setDateRange([null, null]);
    setFilterData(null);
    setNonWorkingErr(false);
    setErrorMsg("");
    formikRef === null || formikRef === void 0 ? void 0 : (_formikRef$current = formikRef.current) === null || _formikRef$current === void 0 ? void 0 : _formikRef$current.setFieldValue("dates", []);
    formikRef === null || formikRef === void 0 ? void 0 : (_formikRef$current2 = formikRef.current) === null || _formikRef$current2 === void 0 ? void 0 : _formikRef$current2.setFieldValue("dateDetails", []);
    formikRef === null || formikRef === void 0 ? void 0 : (_formikRef$current3 = formikRef.current) === null || _formikRef$current3 === void 0 ? void 0 : _formikRef$current3.setFieldValue("totalLeave", 0);
  }, [selectUserList]);
  React.useEffect(function () {
    if (applyLeaveShow !== null && applyLeaveShow !== void 0 && applyLeaveShow.leaveStartDate && type == "edit") {
      var editStartDate = convertUTCToOrganisationTimezoneForOneDateLeave(Number(applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.editStartTime), timeZone);
      var editEndDate = applyLeaveShow !== null && applyLeaveShow !== void 0 && applyLeaveShow.editEndTime ? convertUTCToOrganisationTimezoneForOneDateLeave(Number(applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.editEndTime), timeZone) : null;
      setFilterData(
      //arrayToStringOutput([Number(applyLeaveShow?.leaveStartDate), Number(applyLeaveShow?.leaveEndDate)], timeZone)
      applyLeaveShow !== null && applyLeaveShow !== void 0 && applyLeaveShow.leaveEndDateFormat ? "".concat(applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveStartDateFormat, " - ").concat(applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveEndDateFormat) : applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveStartDateFormat
      // leaveStartDateFormat,
      //       leaveEndDateFormat,
      );
      setDateRange(
      //   [
      //   moment(Number(applyLeaveShow?.leaveStartDate)).toDate(),
      //   moment(Number(applyLeaveShow?.leaveEndDate)).toDate(),
      // ]
      // [
      //   moment(Number(applyLeaveShow?.editStartTime)).toDate(),
      //   moment(Number(applyLeaveShow?.editEndTime)).toDate(),
      // ]
      // [
      //   Number(applyLeaveShow?.editStartTime),
      //   Number(applyLeaveShow?.editEndTime),
      // ]
      [editStartDate, editEndDate]);
    }
  }, [applyLeaveShow]);
  var _React$useContext4 = React.useContext(UserContext),
    user = _React$useContext4.user;
  var leaveSettingsCheckForUser = leaveSettingsUser && leaveSettingsUser !== null && leaveSettingsUser !== void 0 && leaveSettingsUser.approvedList.length ? leaveSettingsUser === null || leaveSettingsUser === void 0 ? void 0 : leaveSettingsUser.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  React.useEffect(function () {
    if (role == "Admin" || leaveSettingsCheckForUser && role != "Admin") {
      if (!userListLoading && !userListError) {
        var _userListData$getUser;
        var temp = [];
        userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListingForLeave) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
          var userId = item.userId,
            displayName = item.displayName;
          return temp.push({
            label: displayName,
            value: userId
          });
        });
        setUserList(temp);
      }
    } else {
      var _temp = [{
        value: user.userId,
        label: user.displayName
      }];
      setUserList(_temp);
    }
  }, [userListData]);
  React.useEffect(function () {
    if (!userWorkDayLoading && !userWorkDayError) {
      var _userWorkDayData$user, _userWorkDayData$user2;
      var wd = userWorkDayData === null || userWorkDayData === void 0 ? void 0 : (_userWorkDayData$user = userWorkDayData.userWorkDaySettingsForLeave) === null || _userWorkDayData$user === void 0 ? void 0 : (_userWorkDayData$user2 = _userWorkDayData$user.userWorkSettings) === null || _userWorkDayData$user2 === void 0 ? void 0 : _userWorkDayData$user2.workingDays;
      if (wd) {
        setWorkingDaysState(wd);
      }
    }
  }, [userWorkDayData]);

  // get system current timezone offset
  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(timeZone).utcOffset();
  var _dateRange = _slicedToArray(dateRange, 2),
    startDate = _dateRange[0],
    endDate = _dateRange[1];
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values, actions) {
      var user, leaveType, dates, dateDetails, reasonForLeave, totalLeave, dateDetailsList, startValueFormate, endValueFormate, variables, _response$data, response, newLeaveId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            user = values.user, leaveType = values.leaveType, dates = values.dates, dateDetails = values.dateDetails, reasonForLeave = values.reasonForLeave, totalLeave = values.totalLeave;
            if (!(totalLeave == 0)) {
              _context4.next = 4;
              break;
            }
            setNonWorkingErr(true);
            return _context4.abrupt("return", null);
          case 4:
            if (!(!dates.length && !dateDetails.length)) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return", null);
          case 6:
            dateDetailsList = dateDetails.map(function (obj, index) {
              return {
                date: obj.date,
                dayType: obj.dayType,
                nonWorkingDayLeaveSession: obj.nonWorkingDayLeaveSession,
                dateFormatEmail: obj.dateFormatEmail
              };
            });
            /* offset check */
            startValueFormate = dates ? moment(dates[0]).tz(timeZone).format("YYYY-MM-DD HH:mm:ss") : null;
            endValueFormate = dates && dates[1] ? moment(dates[1]).tz(timeZone).format("YYYY-MM-DD HH:mm:ss") : null;
            if (zoneoffset !== currentSystemOffset) {
              if (dates) {
                startValueFormate = convertOrganisationTimezoneForfilterDate(moment(dates[0]).format("YYYY-MM-DD HH:mm:ss"), 0, timeZone);
              }
              if (dates && dates[1]) {
                endValueFormate = convertOrganisationTimezoneForfilterDate(moment(dates[1]).format("YYYY-MM-DD HH:mm:ss"), 0, timeZone);
              }
            }
            variables = {
              userId: user,
              leaveType: leaveType,
              startDate: startValueFormate,
              endDate: endValueFormate,
              dateDetails: dateDetailsList,
              leaveReason: encodeHtmlEntities(reasonForLeave),
              totalLeave: totalLeave,
              organisationId: organisationId,
              timeZone: timeZone,
              freePlanStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName
            };
            _context4.prev = 11;
            _context4.next = 14;
            return addLeaveDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_CHART_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  year: currentYear,
                  timeZone: timeZone
                }
              }, {
                query: LEAVE_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  filter: activeTab,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  timeZone: timeZone,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_TYPE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  startTime: Number(leaveBalanceStartDate),
                  endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate)
                }
              }, {
                query: LIST_LEAVE_TYPE_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  userId: selectUserList,
                  startDate: startValueFormate,
                  endDate: endValueFormate
                }
              }]
            });
          case 14:
            response = _context4.sent;
            newLeaveId = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.addLeaveDetails;
            if (!newLeaveId) {
              toast.error("Error Occured, Try again later!");
            } else {
              toast.success("Leave added successfully!");
              if (values.addSupportingDocument) {
                setPendingLeaveContext({
                  leaveId: newLeaveId,
                  leaveType: leaveType,
                  userId: user
                });
                setAttachmentScreen(true);
              } else {
                handleApplyLeaveClose();
                setOldTotalLeave(null);
                setApplyLeaveShow(null);
                actions.resetForm();
                setDateRange([null, null]);
                setFilterData(null);
              }
            }
            _context4.next = 22;
            break;
          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4["catch"](11);
            if (_context4.t0.message !== "") {
              setErrorMsg(_context4.t0.message);
            } else {
              toast.error("Error Occured, Try again later!");
            }
          case 22:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[11, 19]]);
    }));
    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }(), [addLeaveDetails, addLeaveDetailsLoading]);
  var handleEditSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(values, actions) {
      var user, leaveType, dates, dateDetails, reasonForLeave, totalLeave, leaveTypeId, oldLeaveTypeId, dateDetailsList, oldDateDetailsList, startValueFormate, endValueFormate, variables, _response$data2, response, newLeaveId, _applyLeaveShow$leave, leaveListVars, existingAttachment, _applyLeaveShow$leave2;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            user = values.user, leaveType = values.leaveType, dates = values.dates, dateDetails = values.dateDetails, reasonForLeave = values.reasonForLeave, totalLeave = values.totalLeave;
            if (!(Number(totalLeave) == 0)) {
              _context5.next = 4;
              break;
            }
            setNonWorkingErr(true);
            return _context5.abrupt("return", null);
          case 4:
            if (!(!dates.length && !dateDetails.length)) {
              _context5.next = 6;
              break;
            }
            return _context5.abrupt("return", null);
          case 6:
            leaveTypeId = leaveTypeListData === null || leaveTypeListData === void 0 ? void 0 : leaveTypeListData.leaveTypeList.find(function (o) {
              return o.label == values.leaveType;
            });
            oldLeaveTypeId = leaveTypeListData === null || leaveTypeListData === void 0 ? void 0 : leaveTypeListData.leaveTypeList.find(function (o) {
              return o.label == (applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveType);
            }); // console.log({ leaveTypeId });
            dateDetailsList = dateDetails.map(function (obj, index) {
              return {
                date: obj.date,
                dayType: obj.dayType,
                nonWorkingDayLeaveSession: obj.nonWorkingDayLeaveSession,
                dateFormatEmail: obj.dateFormatEmail
              };
            });
            oldDateDetailsList = applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.dateDetails.map(function (obj, index) {
              return {
                date: obj.date,
                dayType: obj.dayType,
                nonWorkingDayLeaveSession: obj.nonWorkingDayLeaveSession,
                dateFormatEmail: obj.dateFormatEmail
              };
            });
            startValueFormate = dates ? moment(dates[0]).tz(timeZone).format("YYYY-MM-DD HH:mm:ss") : null;
            endValueFormate = dates && dates[1] ? moment(dates[1]).tz(timeZone).format("YYYY-MM-DD HH:mm:ss") : null;
            if (zoneoffset !== currentSystemOffset) {
              if (dates) {
                startValueFormate = convertOrganisationTimezoneForfilterDate(moment(dates[0]).format("YYYY-MM-DD HH:mm:ss"), 0, timeZone);
              }
              if (dates && dates[1]) {
                endValueFormate = convertOrganisationTimezoneForfilterDate(moment(dates[1]).format("YYYY-MM-DD HH:mm:ss"), 0, timeZone);
              }
            }
            variables = {
              userId: user,
              leaveType: leaveType,
              startDate: startValueFormate,
              endDate: endValueFormate,
              dateDetails: dateDetailsList,
              leaveReason: encodeHtmlEntities(reasonForLeave),
              totalLeave: Number(totalLeave),
              organisationId: organisationId,
              timeZone: timeZone,
              leaveId: applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveId,
              oldDateDetails: oldDateDetailsList,
              oldLeaveTypeId: oldLeaveTypeId === null || oldLeaveTypeId === void 0 ? void 0 : oldLeaveTypeId.value,
              leaveTypeId: leaveTypeId === null || leaveTypeId === void 0 ? void 0 : leaveTypeId.value,
              oldUserId: applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.userId
            }; // console.log({ variables });
            _context5.prev = 14;
            _context5.next = 17;
            return editLeaveDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_CHART_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  year: currentYear,
                  timeZone: timeZone
                }
              }, {
                query: LEAVE_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  filter: activeTab,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  timeZone: timeZone,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_TYPE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  startTime: Number(leaveBalanceStartDate),
                  endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate)
                }
              }]
            });
          case 17:
            response = _context5.sent;
            newLeaveId = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.editLeaveDetails;
            if (newLeaveId) {
              _context5.next = 23;
              break;
            }
            toast.error("Error Occured, Try again later!");
            _context5.next = 49;
            break;
          case 23:
            leaveListVars = {
              organisationId: organisationId,
              userId: userId,
              filter: activeTab,
              timeZone: timeZone,
              limit: LIMIT,
              offset: 0,
              freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
              freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
              leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
              startTime: leaveStartDateMonthFilter,
              endTime: leaveEndDateMonthFilter
            }; // editing a leave always creates a new leaveId, so any existing attachment
            // has to be either carried over, removed, or replaced against the new id
            existingAttachment = !removeExistingAttachment && (applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : (_applyLeaveShow$leave = applyLeaveShow.leaveAttachments) === null || _applyLeaveShow$leave === void 0 ? void 0 : _applyLeaveShow$leave.length) > 0 ? applyLeaveShow.leaveAttachments[0] : null;
            if (!values.addSupportingDocument) {
              _context5.next = 31;
              break;
            }
            setPendingLeaveContext({
              leaveId: newLeaveId,
              leaveType: leaveType,
              userId: user,
              oldLeaveId: applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveId
            });
            toast.success("Leave edited successfully!");
            setAttachmentScreen(true);
            _context5.next = 49;
            break;
          case 31:
            _context5.prev = 31;
            if (!existingAttachment) {
              _context5.next = 37;
              break;
            }
            _context5.next = 35;
            return addLeaveAttachmentMutation({
              variables: {
                leaveId: newLeaveId,
                organisationId: organisationId,
                leaveType: leaveType,
                attachment: {
                  attachmentName: existingAttachment.attachmentName,
                  attachmentUrl: existingAttachment.attachmentUrl
                },
                oldLeaveId: applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveId,
                userId: user
              },
              refetchQueries: [{
                query: LEAVE_LIST_QUERY,
                variables: leaveListVars
              }]
            });
          case 35:
            _context5.next = 40;
            break;
          case 37:
            if (!(removeExistingAttachment && (applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : (_applyLeaveShow$leave2 = applyLeaveShow.leaveAttachments) === null || _applyLeaveShow$leave2 === void 0 ? void 0 : _applyLeaveShow$leave2.length) > 0)) {
              _context5.next = 40;
              break;
            }
            _context5.next = 40;
            return deleteLeaveAttachmentMutation({
              variables: {
                leaveId: applyLeaveShow.leaveId,
                organisationId: organisationId
              },
              refetchQueries: [{
                query: LEAVE_LIST_QUERY,
                variables: leaveListVars
              }]
            });
          case 40:
            _context5.next = 45;
            break;
          case 42:
            _context5.prev = 42;
            _context5.t0 = _context5["catch"](31);
            toast.error("Leave edited but attachment update failed.");
          case 45:
            handleApplyLeaveClose();
            setApplyLeaveShow(null);
            setRemoveExistingAttachment(false);
            toast.success("Leave edited successfully!");
          case 49:
            _context5.next = 54;
            break;
          case 51:
            _context5.prev = 51;
            _context5.t1 = _context5["catch"](14);
            if (_context5.t1.message !== "") {
              setErrorMsg(_context5.t1.message);
            } else {
              toast.error("Error Occured, Try again later!");
            }
          case 54:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[14, 51], [31, 42]]);
    }));
    return function (_x4, _x5) {
      return _ref6.apply(this, arguments);
    };
  }(), [editLeaveDetails, editLeaveDetailsLoading, addLeaveAttachmentMutation, deleteLeaveAttachmentMutation, applyLeaveShow, leaveTypeListData, removeExistingAttachment]);
  var hideOverlay = function hideOverlay() {
    var _document3, _document3$body, _document3$body$click;
    (_document3 = document) === null || _document3 === void 0 ? void 0 : (_document3$body = _document3.body) === null || _document3$body === void 0 ? void 0 : (_document3$body$click = _document3$body.click) === null || _document3$body$click === void 0 ? void 0 : _document3$body$click.call(_document3$body);
  };
  var applyLeaveModalClose = function applyLeaveModalClose() {
    setDateRange([null, null]);
    setFilterData(null);
    setErrorMsg("");
    setNonWorkingErr(false);
    handleApplyLeaveClose();
    setOldTotalLeave(null);
    setApplyLeaveShow(null);
  };

  // console.log({ holidayYear });
  // console.log({ holidayListData });
  //console.log({filterData})

  // Trigger file input when upload icon clicked
  var handleUpload = function handleUpload() {
    var _fileInputRef$current;
    // Trigger hidden input click
    (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
  };
  var ATTACHMENT_MAX_SIZE = 5 * 1024 * 1024; // 5MB
  var ATTACHMENT_ALLOWED_TYPES = ["application/pdf"];
  var handleAttachmentFileSelect = function handleAttachmentFileSelect(selectedFile) {
    if (!selectedFile) return;
    if (!ATTACHMENT_ALLOWED_TYPES.includes(selectedFile.type)) {
      toast.error("Only PDF files are allowed");
      return;
    }
    if (selectedFile.size > ATTACHMENT_MAX_SIZE) {
      toast.error("File size must be less than or equal to 5MB");
      return;
    }
    setFile(selectedFile);
  };
  var handleAttachmentInputChange = function handleAttachmentInputChange(event) {
    handleAttachmentFileSelect(event.target.files[0]);
    event.target.value = "";
  };
  var handleAttachmentDrop = function handleAttachmentDrop(event) {
    var _event$dataTransfer$f;
    event.preventDefault();
    setIsDragOver(false);
    handleAttachmentFileSelect((_event$dataTransfer$f = event.dataTransfer.files) === null || _event$dataTransfer$f === void 0 ? void 0 : _event$dataTransfer$f[0]);
  };
  var closeAttachmentScreen = function closeAttachmentScreen() {
    var _formikRef$current4;
    // editing creates a new leaveId — if the user skips adding a new document,
    // make sure any attachment still sitting on the old (now replaced) leaveId is cleared
    if (pendingLeaveContext !== null && pendingLeaveContext !== void 0 && pendingLeaveContext.oldLeaveId) {
      deleteLeaveAttachmentMutation({
        variables: {
          leaveId: pendingLeaveContext.oldLeaveId,
          organisationId: organisationId
        }
      })["catch"](function () {});
    }
    handleApplyLeaveClose();
    setOldTotalLeave(null);
    setApplyLeaveShow(null);
    (_formikRef$current4 = formikRef.current) === null || _formikRef$current4 === void 0 ? void 0 : _formikRef$current4.resetForm();
    setDateRange([null, null]);
    setFilterData(null);
    setAttachmentScreen(false);
    setPendingLeaveContext(null);
    setRemoveExistingAttachment(false);
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };
  var handleFinishAttachmentUpload = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _yield$apolloClient$q, presignedData, _presignedData$getLea, uploadURL, key, CLOUDFLARE_BASE_URL, uploadResponse;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (file) {
              _context6.next = 3;
              break;
            }
            toast.error("Please select a file to upload");
            return _context6.abrupt("return");
          case 3:
            setIsUploading(true);
            _context6.prev = 4;
            _context6.next = 7;
            return apolloClient.query({
              query: GET_PRE_SIGNED_URL,
              variables: {
                fileType: file.type
              },
              fetchPolicy: "no-cache"
            });
          case 7:
            _yield$apolloClient$q = _context6.sent;
            presignedData = _yield$apolloClient$q.data;
            _presignedData$getLea = presignedData.getLeaveAttachmentUploadUrl, uploadURL = _presignedData$getLea.uploadURL, key = _presignedData$getLea.key;
            CLOUDFLARE_BASE_URL = "https://leave-files.getworkfolio.com";
            _context6.next = 13;
            return fetch(uploadURL, {
              method: "PUT",
              headers: {
                "Content-Type": file.type
              },
              body: file
            });
          case 13:
            uploadResponse = _context6.sent;
            if (uploadResponse.ok) {
              _context6.next = 16;
              break;
            }
            throw new Error("Upload failed");
          case 16:
            _context6.next = 18;
            return addLeaveAttachmentMutation({
              variables: {
                leaveId: pendingLeaveContext === null || pendingLeaveContext === void 0 ? void 0 : pendingLeaveContext.leaveId,
                organisationId: organisationId,
                leaveType: pendingLeaveContext === null || pendingLeaveContext === void 0 ? void 0 : pendingLeaveContext.leaveType,
                attachment: {
                  attachmentName: file.name,
                  attachmentUrl: "".concat(CLOUDFLARE_BASE_URL, "/").concat(key)
                },
                oldLeaveId: pendingLeaveContext === null || pendingLeaveContext === void 0 ? void 0 : pendingLeaveContext.oldLeaveId,
                userId: pendingLeaveContext === null || pendingLeaveContext === void 0 ? void 0 : pendingLeaveContext.userId
              },
              refetchQueries: [{
                query: LEAVE_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  filter: activeTab,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }]
            });
          case 18:
            toast.success("Attachment uploaded successfully!");
            closeAttachmentScreen();
            _context6.next = 25;
            break;
          case 22:
            _context6.prev = 22;
            _context6.t0 = _context6["catch"](4);
            toast.error("Failed to upload attachment. Please try again.");
          case 25:
            _context6.prev = 25;
            setIsUploading(false);
            return _context6.finish(25);
          case 28:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[4, 22, 25, 28]]);
    }));
    return function handleFinishAttachmentUpload() {
      return _ref7.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: applyLeaveShow == false ? false : true,
    onHide: attachmentScreen ? closeAttachmentScreen : applyLeaveModalClose,
    animation: false,
    size: "lg",
    backdrop: "static",
    className: "apply-leave-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "apply-leave-modal-header-title"
  }, attachmentScreen ? "Add Attachment" : type == "add" ? "Apply Leave" : "Edit Leave")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "apply-leave-modal-body"
  }, attachmentScreen ? /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen-success-banner"
  }, /*#__PURE__*/React.createElement(FiCheckCircle, {
    className: "apply-leave-modal-attachment-screen-success-banner-icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen-success-banner-title"
  }, type === "edit" ? "Leave request updated successfully" : "Leave request submitted successfully"), /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen-success-banner-subtitle"
  }, "Add a supporting document to complete your request."))), /*#__PURE__*/React.createElement("div", {
    className: isDragOver ? "apply-leave-modal-attachment-screen-dropzone apply-leave-modal-attachment-screen-dropzone-dragover" : "apply-leave-modal-attachment-screen-dropzone",
    onClick: handleUpload,
    onDragOver: function onDragOver(e) {
      e.preventDefault();
      setIsDragOver(true);
    },
    onDragLeave: function onDragLeave() {
      return setIsDragOver(false);
    },
    onDrop: handleAttachmentDrop
  }, /*#__PURE__*/React.createElement(FiUpload, {
    className: "apply-leave-modal-attachment-screen-dropzone-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen-dropzone-title"
  }, file ? file.name : "Upload Attachment"), file ? /*#__PURE__*/React.createElement(VscClose, {
    className: "apply-leave-modal-attachment-screen-dropzone-remove-icon",
    onClick: function onClick(e) {
      e.stopPropagation();
      setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen-dropzone-text"
  }, "Drag and drop your file here"), /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen-dropzone-or"
  }, "or"), /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "apply-leave-modal-attachment-screen-dropzone-browse-button",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleUpload();
    }
  }, "Browse Files")), /*#__PURE__*/React.createElement("input", {
    type: "file",
    ref: fileInputRef,
    style: {
      display: "none"
    },
    accept: "application/pdf",
    onChange: handleAttachmentInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen-hint"
  }, "PDF \xB7 Maximum 5 MB"), /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-attachment-screen-actions"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    disabled: isUploading,
    onClick: closeAttachmentScreen
  }, "Skip"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    disabled: isUploading,
    onClick: handleFinishAttachmentUpload
  }, isUploading ? "Uploading..." : "Upload & Finish"))) : /*#__PURE__*/React.createElement(Formik, {
    innerRef: formikRef,
    initialValues: {
      user: type == "edit" ? userId : userId,
      leaveType: type == "edit" ? applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveType : "",
      dates: type == "edit" ? [applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveStartDateFormat, applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveEndDateFormat] : [],
      dateDetails: type == "edit" ? applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.dateDetails : [],
      reasonForLeave: type == "edit" ? applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveReason : "",
      totalLeave: type == "edit" ? applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : applyLeaveShow.leaveDays : 0,
      addSupportingDocument: false
    },
    validationSchema: ApplyLeaveSchema,
    onSubmit: type !== "edit" ? handleSubmit : handleEditSubmit
  }, function (_ref8) {
    var _applyLeaveShow$leave3, _values$dates;
    var setFieldValue = _ref8.setFieldValue,
      errors = _ref8.errors,
      touched = _ref8.touched,
      values = _ref8.values;
    var leaveSettingsTypeData = leaveTypeListData === null || leaveTypeListData === void 0 ? void 0 : leaveTypeListData.leaveTypeList.find(function (o) {
      return o.label == values.leaveType;
    });
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form-div"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, role == "Admin" || leaveSettingsCheckForUser && role != "Admin" ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "user"
    }, function (_ref9) {
      var field = _ref9.field,
        form = _ref9.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Employee Name"), errors.user && touched.user ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error apply-leave-modal-error"
      }, errors.user) : null, /*#__PURE__*/React.createElement(FormControl, {
        as: "select",
        className: "apply-leave-modal-body-wrapper-form-div-field-input apply-leave-modal-user-select",
        onChange: function onChange(e) {
          setFieldValue("user", e.target.value);
          setSelectUserList(e.target.value);
        },
        value: values.user,
        disabled: type == "edit"
        //{...field}
      }, /*#__PURE__*/React.createElement("option", {
        key: "select-user",
        value: " "
      }, "Select User"), userList === null || userList === void 0 ? void 0 : userList.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.label);
      })));
    }))) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "leaveType"
    }, function (_ref10) {
      var _leaveTypeListData$le;
      var field = _ref10.field,
        form = _ref10.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Leave Type"), errors.leaveType && touched.leaveType ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error apply-leave-modal-error"
      }, errors.leaveType) : null, leaveTypeListLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        className: "apply-leave-modal-body-wrapper-form-div-field-input"
      }, field, {
        onChange: function onChange(e) {
          field.onChange(e);
          setErrorMsg("");
          setNonWorkingErr(false);
        }
      }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("option", {
        key: "select-leave-type",
        value: " "
      }, "Select Leave Type"), leaveTypeListData === null || leaveTypeListData === void 0 ? void 0 : (_leaveTypeListData$le = leaveTypeListData.leaveTypeList) === null || _leaveTypeListData$le === void 0 ? void 0 : _leaveTypeListData$le.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.label
        }, key.label);
      }))));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "dates"
    }, function (_ref11) {
      var _holidayListData$holi;
      var field = _ref11.field,
        form = _ref11.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "apply-leave-modal-body-wrapper-form-div-field-form-group"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Leave Dates"), errors.dates && touched.dates ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error apply-leave-modal-error"
      }, errors.dates) : null, " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
        trigger: "click",
        rootClose: true,
        placement: "bottom",
        overlay: /*#__PURE__*/React.createElement(Popover, {
          className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-trigger"
        }, /*#__PURE__*/React.createElement(Popover.Content, null, permissionSettingLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(TimeFilter, {
          onClose: hideOverlay,
          setFilterData: setFilterData,
          setDateRange: setDateRange,
          startDate: startDate,
          endDate: endDate,
          setFieldValue: setFieldValue,
          holidayListData: holidayListData === null || holidayListData === void 0 ? void 0 : (_holidayListData$holi = holidayListData.holidayList) === null || _holidayListData$holi === void 0 ? void 0 : _holidayListData$holi.holidayData,
          workingDays: workingDaysState,
          setNonWorkingErr: setNonWorkingErr,
          setErrorMsg: setErrorMsg,
          timeZone: timeZone,
          organisationBilling: organisationBilling,
          permissionSettingData: permissionSettingData,
          holidayYear: holidayYear,
          setHolidayYear: setHolidayYear,
          dateRange: dateRange,
          modalType: type,
          userId: values.user
        })))
      }, /*#__PURE__*/React.createElement("div", {
        id: "date-filter",
        className: "apply-leave-modal-body-wrapper-form-date-picker-filter-date apply-leave-modal-body-wrapper-form-div-field-input"
      }, /*#__PURE__*/React.createElement(MdDateRange, {
        className: "apply-leave-modal-body-wrapper-form-date-picker-filter-date-icon"
      }), filterData ? /*#__PURE__*/React.createElement("p", {
        className: "apply-leave-modal-body-wrapper-form-date-picker-filter-date-text"
      }, filterData) : /*#__PURE__*/React.createElement("p", {
        className: "apply-leave-modal-body-wrapper-form-date-picker-filter-date-text"
      }, "Select Date"))));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "reasonForLeave"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name "
      }, "Leave Reason"), errors.reasonForLeave && touched.reasonForLeave ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error apply-leave-modal-error"
      }, errors.reasonForLeave) : null, /*#__PURE__*/React.createElement("textarea", _extends({
        className: "text-area apply-leave-modal-body-wrapper-form-field-text-area"
      }, field, fieldProps)));
    }))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" ? type === "edit" && !removeExistingAttachment && (applyLeaveShow === null || applyLeaveShow === void 0 ? void 0 : (_applyLeaveShow$leave3 = applyLeaveShow.leaveAttachments) === null || _applyLeaveShow$leave3 === void 0 ? void 0 : _applyLeaveShow$leave3.length) > 0 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: "my-projects-modal-content-name-field"
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
    }, "Upload Attachment (Optional)"), /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form-div-existing-attachment",
      title: applyLeaveShow.leaveAttachments[0].attachmentName
    }, /*#__PURE__*/React.createElement("span", {
      className: "apply-leave-modal-body-wrapper-form-div-existing-attachment-text"
    }, applyLeaveShow.leaveAttachments[0].attachmentName), /*#__PURE__*/React.createElement(VscClose, {
      className: "apply-leave-modal-body-wrapper-form-div-existing-attachment-remove-icon",
      onClick: function onClick() {
        return setRemoveExistingAttachment(true);
      }
    }))))) : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: "my-projects-modal-content-name-field apply-leave-modal-body-wrapper-form-div-attachment-checkbox-group"
    }, /*#__PURE__*/React.createElement("label", {
      className: "apply-leave-modal-body-wrapper-form-div-attachment-checkbox-label"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "apply-leave-modal-body-wrapper-form-div-attachment-checkbox",
      checked: values.addSupportingDocument,
      onChange: function onChange(e) {
        return setFieldValue("addSupportingDocument", e.target.checked);
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "apply-leave-modal-body-wrapper-form-div-attachment-checkbox-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "apply-leave-modal-body-wrapper-form-div-attachment-checkbox-title"
    }, "Upload Attachment (Optional)"), /*#__PURE__*/React.createElement("span", {
      className: "apply-leave-modal-body-wrapper-form-div-attachment-checkbox-subtitle"
    }, "You can upload the attachment on the next screen.")))))) : null)))), /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
    }, "Your Leave Details"), /*#__PURE__*/React.createElement("div", {
      className: role == "Member" ? "apply-leave-modal-body-wrapper-summary-content-member" : "apply-leave-modal-body-wrapper-summary-content"
    }, /*#__PURE__*/React.createElement(FieldArray, {
      name: "dateDetails",
      render: function render(dateArrayHelpers) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, values.dateDetails.length >= 1 ? values.dateDetails.map(function (day, dayIndex) {
          return /*#__PURE__*/React.createElement(Form, {
            key: "day-".concat(dayIndex)
          }, /*#__PURE__*/React.createElement("div", {
            className: "apply-leave-modal-body-wrapper-summary-content-row"
          }, /*#__PURE__*/React.createElement("div", {
            className: "apply-leave-modal-body-wrapper-summary-content-row"
          }, /*#__PURE__*/React.createElement("span", null, day.dateFormat), /*#__PURE__*/React.createElement("span", {
            className: "apply-leave-modal-body-wrapper-summary-content-row-date-span"
          }, "(".concat(day.dayFormat, ")"))), /*#__PURE__*/React.createElement(Field, {
            name: "dateDetails[".concat(dayIndex, "].dayType")
          }, function (_ref12) {
            var field = _ref12.field,
              form = _ref12.form;
            return /*#__PURE__*/React.createElement(FormGroup, {
              style: {
                width: "".concat(values.dateDetails[dayIndex].dayType == "full-day" ? 100 : values.dateDetails[dayIndex].dayType == "half-day-first-half" ? 165 : 170, "px")
              }
            }, values.dateDetails[dayIndex].dayType == "non-working-day" && (values.dateDetails[dayIndex].nonWorkingDayLeaveSession == null || values.dateDetails[dayIndex].nonWorkingDayLeaveSession == "full-day") ? /*#__PURE__*/React.createElement("div", {
              className: "apply-leave-modal-body-wrapper-summary-content-non-working-text"
            }, "Non Working day") : /*#__PURE__*/React.createElement(Select, _extends({}, field, {
              value: daysList.filter(function (option) {
                if (field.value.includes(option.value) && !field.value.includes("non-working-day")) {
                  return true;
                } else if (field.value.includes(option.value) && field.value.includes("non-working-day") && values.dateDetails[dayIndex].nonWorkingDayLeaveSession == null) {
                  return true;
                } else if (field.value.includes("non-working-day") && values.dateDetails[dayIndex].nonWorkingDayLeaveSession == "half-day-first-half" && option.value == "half-day-first-half") {
                  return true;
                } else if (field.value.includes("non-working-day") && values.dateDetails[dayIndex].nonWorkingDayLeaveSession == "half-day-second-half" && option.value == "half-day-second-half") {
                  return true;
                }
              }),
              onChange: function onChange(e) {
                if (values.dateDetails[dayIndex].dayType == "non-working-day" && values.dateDetails[dayIndex].nonWorkingDayLeaveSession == "half-day-first-half" || values.dateDetails[dayIndex].dayType == "non-working-day" && values.dateDetails[dayIndex].nonWorkingDayLeaveSession == "half-day-second-half") {
                  return null;
                }
                var beforeChangedDayType = values.dateDetails[dayIndex].dayType;
                var beforeChangedDays = beforeChangedDayType == "full-day" ? 1 : 0.5;
                form.setFieldValue("dateDetails[".concat(dayIndex, "].dayType"), e.value);
                var leaveDays = e.value == "full-day" ? 1 : 0.5;
                var totalLeaveTemp = 0;
                if (beforeChangedDayType != "full-day" && e.value == "full-day") {
                  totalLeaveTemp = Number(values.totalLeave) - beforeChangedDays;
                  totalLeaveTemp = Number(totalLeaveTemp) + leaveDays;
                } else if (beforeChangedDayType != "full-day" && e.value != "full-day" || beforeChangedDayType == "full-day" && e.value == "full-day") {
                  totalLeaveTemp = Number(values.totalLeave);
                } else {
                  totalLeaveTemp = Number(values.totalLeave) - leaveDays;
                }
                form.setFieldValue("totalLeave", totalLeaveTemp);
              },
              options: values.dateDetails[dayIndex].dayType == "non-working-day" && values.dateDetails[dayIndex].nonWorkingDayLeaveSession == "half-day-first-half" ? daysListFirstHalf : values.dateDetails[dayIndex].dayType == "non-working-day" && values.dateDetails[dayIndex].nonWorkingDayLeaveSession == "half-day-second-half" ? daysListSecondHalf : daysList,
              components: {
                IndicatorSeparator: function IndicatorSeparator() {
                  return null;
                }
              },
              menuPortalTarget: document.body,
              styles: {
                menuPortal: function menuPortal(base) {
                  return _objectSpread(_objectSpread({}, base), {}, {
                    zIndex: 9999,
                    width: "150px",
                    menuPlacement: "auto"
                  });
                },
                control: function control(base) {
                  return _objectSpread(_objectSpread({}, base), {}, {
                    border: 0,
                    boxShadow: "none"
                  });
                }
              },
              className: "apply-leave-modal-body-wrapper-summary-content-row-day-select"
            })));
          })));
        }) : /*#__PURE__*/React.createElement("div", {
          className: "apply-leave-modal-body-wrapper-summary-content-select-dates"
        }, "Yet to select dates"));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-summary-footer"
    }, /*#__PURE__*/React.createElement("div", null, "Total Leave"), /*#__PURE__*/React.createElement("div", null, Number(values.totalLeave) > 1 ? "".concat(values.totalLeave, " days") : "".concat(values.totalLeave, " day"))))), /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form-footer"
    }, values.leaveType !== "" && leaveSettingsTypeData && values.dates[0] && leaveSettingsTypeData !== null && leaveSettingsTypeData !== void 0 && leaveSettingsTypeData.leaveTypeCount || (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) == 0 ? /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-sub"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-span"
    }, "As of ", values.dates ? moment(values.dates[0]).tz(timeZone).format("DD MMM, YYYY") : null, " "), /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-label"
    }, "Available leave"), /*#__PURE__*/React.createElement("div", null, leaveSettingsTypeData.available || leaveSettingsTypeData.available == 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) >= 0 ? leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available : 0, " ", (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) >= 1 ? "days" : "day") : (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== 0 && (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== null ? (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) !== null ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== 0 && Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== 1 ? "days" : "day") : /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== 0 && Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== 1 ? "days" : "day") : /*#__PURE__*/React.createElement(React.Fragment, null, leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount, " ", (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) !== 0 && (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) !== 1 ? "days" : "day")), " "), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-label"
    }, "Currently selected", " "), /*#__PURE__*/React.createElement("div", null, Number(values.totalLeave) > 1 ? "".concat(values.totalLeave, " days") : "".concat(values.totalLeave, " day"), " ")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-label"
    }, "Balance leave", " "), /*#__PURE__*/React.createElement("div", null, leaveSettingsTypeData.available || leaveSettingsTypeData.available == 0 ? type == "edit" && values.totalLeave == oldTotalLeave ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) > 1 ? "days" : "day", " ") : "No days left ") : type == "edit" && oldTotalLeave && values.totalLeave ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) + (Number(oldTotalLeave) - Number(values.totalLeave)) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) + (Number(oldTotalLeave) - Number(values.totalLeave)), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) + (Number(oldTotalLeave) - Number(values.totalLeave)) > 1 ? "days" : "day", " ", /*#__PURE__*/React.createElement("span", null, "(after booked)")) : "No days left (after booked)") : /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) - Number(values.totalLeave) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) - Number(values.totalLeave), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.available) - Number(values.totalLeave) > 1 ? "days" : "day", " ", /*#__PURE__*/React.createElement("span", null, "(after booked)")) : "No days left (after booked)") : type == "edit" && values.totalLeave == oldTotalLeave ? (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== 0 && (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== null ? (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) !== null ? Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) > 1 ? "days" : "day", " ") : "No days left " : "-" : /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) > 1 ? "days" : "day", " ") : "No days left ") : type == "edit" && values.totalLeave && oldTotalLeave ? (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== 0 && (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== null ? (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) !== null ? Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) + (Number(oldTotalLeave) - Number(values.totalLeave)), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) + (Number(oldTotalLeave) - Number(values.totalLeave)) > 1 ? "days" : "day", " ") : "No days left " : "-" : /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) + (Number(oldTotalLeave) - Number(values.totalLeave)) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) + (Number(oldTotalLeave) - Number(values.totalLeave)), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) + (Number(oldTotalLeave) - Number(values.totalLeave)) > 1 ? "days" : "day", " ") : "No days left ") : (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== 0 && (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) !== null ? (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) !== null ? Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) - Number(values.totalLeave) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) - Number(values.totalLeave), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.takenLeave) - Number(values.totalLeave) > 1 ? "days" : "day", " ", /*#__PURE__*/React.createElement("span", null, "(after booked)")) : "No days left (after booked)" : "-" : /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(values.totalLeave) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(values.totalLeave), " ", Number(leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveTypeCount) - Number(values.totalLeave) > 1 ? "days" : "day", " ", /*#__PURE__*/React.createElement("span", null, "(after booked)")) : "No days left (after booked)"))))), (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveSettings) == "Annually" ? /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-sub-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-span"
    }, "As of", " ", values !== null && values !== void 0 && (_values$dates = values.dates) !== null && _values$dates !== void 0 && _values$dates.length ? function () {
      var selected = moment(values.dates[0]).tz(timeZone);
      if ((leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.leaveYearSettingsData) === "financial-year") {
        var fyEndYear = selected.month() >= 3 // April = 3
        ? selected.year() + 1 : selected.year();
        return moment.tz("".concat(fyEndYear, "-03-31"), "YYYY-MM-DD", timeZone).format("DD MMM, YYYY");
      }

      // Calendar year
      return selected.endOf("year").format("DD MMM, YYYY");
    }() : "-"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-label"
    }, "Estimated balance", " "), /*#__PURE__*/React.createElement("div", null, " ", (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.yearWiseLeave) > 0 ? leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.yearWiseLeave : 0, " ", (leaveSettingsTypeData === null || leaveSettingsTypeData === void 0 ? void 0 : leaveSettingsTypeData.yearWiseLeave) >= 1 ? "days" : "day"))) : /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-extra-box-text-header-sub-2"
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button"
    }, nonWorkingErr ? /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-text"
    }, "Choose the valid day to apply the leave") : null, errorMsg !== "" ? /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-text"
    }, " ", errorMsg) : null, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "apply-leave-footer-apply-leave-button",
      type: "submit",
      disabled: addLeaveDetailsLoading || editLeaveDetailsLoading || isUploading
    }, addLeaveDetailsLoading || editLeaveDetailsLoading || isUploading ? "Loading..." : type == "add" ? "Apply Leave" : "Update Changes"))));
  })));
}
var convertUTCToOrganisationTimezoneForOneDateLeave = function convertUTCToOrganisationTimezoneForOneDateLeave(date, tz) {
  var startTime = null;
  var timezoneObject = tz;
  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = currentSystemOffset;
  if (zoneoffset < 0) {
    zoneoffset = Math.abs(zoneoffset);
    startTime = moment(date).add(zoneoffset, "minutes").toDate();
  } else {
    startTime = moment(date).subtract(zoneoffset, "minutes").toDate();
  }
  return startTime;
};

// export function TimeFilter(props) {
//   const {
//     onClose,
//     setFilterData,
//     setDateRange,
//     startDate,
//     endDate,
//     setFieldValue,
//     holidayListData,
//     workingDays,
//     setNonWorkingErr,
//     setErrorMsg,
//     timeZone,
//     organisationBilling,
//     permissionSettingData,
//     holidayYear,
//     setHolidayYear,
//     dateRange,
//     modalType,
//     userId
//   } = props;

//   // -----------------------------------------------------
//   // ⭐ FIX #1 — Remove timezone from DatePicker dates
//   //     Converts JS date (UTC+14) → Pure date (no offset)
//   // -----------------------------------------------------
//   const normalizePickerDate = (date) => {
//     if (!date) return null;

//     // Convert DatePicker timestamp → "YYYY-MM-DD" string
//     const pureDateStr = moment(date).format("YYYY-MM-DD");

//     // Convert THAT string back to JS Date WITHOUT timezone offset
//     return new Date(pureDateStr);
//   };

//   // -----------------------------------------------------
//   // ⭐ FIX #2 — interpret normalized dates in ORG timezone
//   // -----------------------------------------------------
//   const toOrgMoment = (date, orgTZ) => {
//     const dateStr = moment(date).format("YYYY-MM-DD");
//     return moment.tz(dateStr, "YYYY-MM-DD", orgTZ).startOf("day");
//   };

//   // -----------------------------------------------------
//   // ⭐ FIX #3 — Complete no-shift leave calculation
//   // -----------------------------------------------------
//   const getDateDetailsData = async (date) => {
//     const [startD, endD] = date;

//     if (!startD) {
//       setFieldValue("dateDetails", []);
//       setFieldValue("totalLeave", 0);
//       return;
//     }

//     const orgTZ = timeZone;

//     // Always interpret in ORG timezone
//     const startOrg = toOrgMoment(startD, orgTZ);
//     const endOrg = endD ? toOrgMoment(endD, orgTZ) : startOrg.clone();

//     const daysDiff = endOrg.diff(startOrg, "days");

//     let totalLeave = 0;
//     let details = [];

//     const workDayList = workingDays ? workingDays.split(",") : [];

//     for (let i = 0; i <= daysDiff; i++) {
//       const currentOrg = startOrg.clone().add(i, "days");

//       const dateKey = currentOrg.format("YYYY-MM-DD");
//       const weekday = currentOrg.format("dddd");

//       const isWorkingDay =
//         workDayList.length === 0 ? true : workDayList.includes(weekday);

//       // -------------------------------------------------
//       // ⭐ Holiday check — compare ONLY in ORG timezone
//       // -------------------------------------------------
//       const holidayIndex = holidayListData
//         ? holidayListData.findIndex((h) => {
//             const holidayDate = moment
//               .unix(h.date / 1000)
//               .tz(orgTZ)
//               .format("YYYY-MM-DD");

//             const isPublic =
//               h.holidayVisibility === "public" || h.holidayVisibility == null;

//             const isPrivate =
//               h.holidayVisibility === "private" &&
//               h.leaveUser?.some((u) => u.userId === userId);

//             return (isPublic || isPrivate) && holidayDate === dateKey;
//           })
//         : -1;

//       // -------------------------------------------------
//       // ⭐ Leave counting
//       // -------------------------------------------------
//       if (holidayIndex >= 0) {
//         const session = holidayListData[holidayIndex]?.session;

//         if (session !== "full-day") totalLeave += 0.5;
//       } else if (isWorkingDay) {
//         totalLeave += 1;
//       }

//       // -------------------------------------------------
//       // ⭐ Map holiday session types
//       // -------------------------------------------------
//       let nonWorkingSession = null;

//       if (holidayIndex >= 0) {
//         const s = holidayListData[holidayIndex]?.session;

//         if (s === "half-day-first-half") nonWorkingSession = "half-day-second-half";
//         else if (s === "half-day-second-half") nonWorkingSession = "half-day-first-half";
//         else nonWorkingSession = s;
//       }

//       // -------------------------------------------------
//       // ⭐ Build UI output
//       // -------------------------------------------------
//       details.push({
//         date: currentOrg.format("DD-MM-YYYY"),
//         dateFormat: currentOrg.format("DD MMM"),
//         dateFormatEmail: currentOrg.format("DD MMM, YYYY"),
//         dayFormat: currentOrg.format("ddd"),
//         dayType: holidayIndex >= 0 || !isWorkingDay ? "non-working-day" : "full-day",
//         nonWorkingDayLeaveSession: nonWorkingSession
//       });
//     }

//     setFieldValue("dateDetails", details);
//     setFieldValue("totalLeave", totalLeave);
//     setNonWorkingErr(false);
//     setErrorMsg("");
//   };

//   // Re-run when holiday list loads
//   React.useEffect(() => {
//     if (!holidayListData || !dateRange || !dateRange[0]) return;
//     getDateDetailsData(dateRange);
//   }, [holidayListData]);

//   // -----------------------------------------------------
//   // ⭐ FIX #4 — Normalize DatePicker selection BEFORE use
//   // -----------------------------------------------------
//   const handleDateChange = async (dates) => {
//     const normalized = dates.map((d) => (d ? normalizePickerDate(d) : null));

//     setDateRange(normalized);
//     setFieldValue("dates", normalized);
//     setFilterData(arrayToStringOutput(normalized, timeZone));

//     const [s, e] = normalized;

//     if (
//       holidayYear[0] !== moment(s).format("YYYY") ||
//       holidayYear[1] !== moment(e || s).format("YYYY")
//     ) {
//       setHolidayYear([
//         moment(s).format("YYYY"),
//         moment(e || s).format("YYYY"),
//       ]);
//     } else {
//       getDateDetailsData(normalized);
//     }
//   };

//   return (
//     <>
//       <div className="apply-leave-modal-body-wrapper-form-date-picker-filter-overlay">
//         <div
//           className="apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-close-icon-div"
//           onClick={onClose}
//         >
//           <VscClose className="apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-close-icon" />
//         </div>

//         <div className="apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-datepicker">
//           <DatePicker
//             inline
//             selected={startDate}
//             onChange={(dates) => {
//               handleDateChange(dates);
//               onClose();
//             }}
//             startDate={startDate}
//             endDate={endDate}
//             selectsRange={true}
//           />
//         </div>
//       </div>
//     </>
//   );
// }
// export function TimeFilter(props) {
//   const {
//     onClose,
//     setFilterData,
//     setDateRange,
//     startDate,
//     endDate,
//     setFieldValue,
//     holidayListData,
//     workingDays,
//     setNonWorkingErr,
//     setErrorMsg,
//     timeZone,
//     holidayYear,
//     setHolidayYear,
//     dateRange,
//     userId
//   } = props;

//   // ------------------------------------------------------------
//   // ⭐ 1. PURE DATE for DatePicker (no timezone interaction)
//   // ------------------------------------------------------------
//   const toPureDate = (d) =>
//     d ? new Date(d.getFullYear(), d.getMonth(), d.getDate()) : null;

//   // ------------------------------------------------------------
//   // ⭐ 2. Normalize for ORG TZ calculations (NOT UI)
//   // ------------------------------------------------------------
//   const normalizeToOrgTZ = (date, orgTZ) => {
//     if (!date) return null;
//     return moment.tz(
//       {
//         year: date.getFullYear(),
//         month: date.getMonth(),
//         day: date.getDate(),
//       },
//       orgTZ
//     ).startOf("day");
//   };

//   // ------------------------------------------------------------
//   // ⭐ 3. Display formatting — use PURE UI DATE (no timezone)
//   // ------------------------------------------------------------
//   const formatDisplayDate = (date) => {
//     if (!date) return "";
//     const y = date.getFullYear();
//     const m = date.getMonth();
//     const d = date.getDate();
//     return moment({ year: y, month: m, date: d }).format("DD MMM, YYYY");
//   };

//   // ------------------------------------------------------------
//   // ⭐ 4. MAIN LEAVE CALCULATION (ORG TZ ONLY)
//   // ------------------------------------------------------------
//   const getDateDetailsData = async (dates) => {
//     const [s, e] = dates;

//     if (!s) {
//       setFieldValue("dateDetails", []);
//       setFieldValue("totalLeave", 0);
//       return;
//     }

//     const orgTZ = timeZone;

//     const startOrg = normalizeToOrgTZ(s, orgTZ);
//     const endOrg = e ? normalizeToOrgTZ(e, orgTZ) : startOrg.clone();

//     const diff = endOrg.diff(startOrg, "days");
//     let totalLeave = 0;
//     const details = [];

//     const workList = workingDays ? workingDays.split(",") : [];

//     for (let i = 0; i <= diff; i++) {
//       const day = startOrg.clone().add(i, "days");

//       const key = day.format("YYYY-MM-DD");
//       const weekday = day.format("dddd");
//       const working = workList.length === 0 || workList.includes(weekday);

//       // Holiday match
//       const holidayIndex = holidayListData
//         ? holidayListData.findIndex((h) => {
//             const hDate = moment.unix(h.date / 1000).tz(orgTZ).format("YYYY-MM-DD");

//             const pub =
//               h.holidayVisibility === "public" ||
//               h.holidayVisibility == null;

//             const priv =
//               h.holidayVisibility === "private" &&
//               h.leaveUser?.some((u) => u.userId === userId);

//             return (pub || priv) && hDate === key;
//           })
//         : -1;

//       // Leave count logic
//       if (holidayIndex >= 0) {
//         const session = holidayListData[holidayIndex]?.session;
//         if (session !== "full-day") totalLeave += 0.5;
//       } else if (working) {
//         totalLeave += 1;
//       }

//       details.push({
//         date: day.format("DD-MM-YYYY"),
//         dateFormat: day.format("DD MMM"),
//         dayFormat: day.format("ddd"),
//         dayType:
//           holidayIndex >= 0 || !working ? "non-working-day" : "full-day",
//       });
//     }

//     setFieldValue("dateDetails", details);
//     setFieldValue("totalLeave", totalLeave);
//     setNonWorkingErr(false);
//     setErrorMsg("");
//   };

//   // ------------------------------------------------------------
//   // ⭐ 5. DatePicker Change Handler
//   // ------------------------------------------------------------
//   const handleDateChange = (dates) => {
//     setDateRange(dates);
//     setFieldValue("dates", dates);

//     const [s, e] = dates;

//     // ⭐ DISPLAY FIX — use PURE date for input field
//     let formatted = "";
//     if (s && !e) formatted = formatDisplayDate(s);
//     if (s && e)
//       formatted = formatDisplayDate(s) + " - " + formatDisplayDate(e);

//     setFilterData(formatted);

//     if (!s) return;

//     // Refresh holidays by year if needed
//     if (
//       holidayYear[0] !== moment(s).format("YYYY") ||
//       holidayYear[1] !== moment(e || s).format("YYYY")
//     ) {
//       setHolidayYear([
//         moment(s).format("YYYY"),
//         moment(e || s).format("YYYY"),
//       ]);
//     } else {
//       getDateDetailsData(dates);
//     }
//   };

//   // ------------------------------------------------------------
//   // ⭐ 6. Recalculate when holidays loaded
//   // ------------------------------------------------------------
//   React.useEffect(() => {
//     if (!holidayListData || !dateRange || !dateRange[0]) return;
//     getDateDetailsData(dateRange);
//   }, [holidayListData]);

//   return (
//     <>
//       <div className="apply-leave-modal-body-wrapper-form-date-picker-filter-overlay">
//         <div
//           className="apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-close-icon-div"
//           onClick={onClose}
//         >
//           <VscClose />
//         </div>

//         <div className="apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-datepicker">
//           <DatePicker
//             inline
//             selected={toPureDate(startDate)}
//             startDate={toPureDate(startDate)}
//             endDate={toPureDate(endDate)}
//             selectsRange={true}
//             onChange={(dates) => {
//               handleDateChange(dates);
//               onClose();
//             }}
//             dateFormat="dd MMM, yyyy" // readable and stable
//           />
//         </div>
//       </div>
//     </>
//   );
// }

export function TimeFilter(props) {
  var _permissionSettingDat;
  var onClose = props.onClose,
    setFilterData = props.setFilterData,
    setDateRange = props.setDateRange,
    startDate = props.startDate,
    endDate = props.endDate,
    setFieldValue = props.setFieldValue,
    holidayListData = props.holidayListData,
    workingDays = props.workingDays,
    setNonWorkingErr = props.setNonWorkingErr,
    setErrorMsg = props.setErrorMsg,
    timeZone = props.timeZone,
    holidayYear = props.holidayYear,
    setHolidayYear = props.setHolidayYear,
    dateRange = props.dateRange,
    userId = props.userId,
    permissionSettingData = props.permissionSettingData,
    organisationBilling = props.organisationBilling;
  var datePickerMinDate = stringToArrayOutput("Free Plan Days");
  var datepickerPermissionForPast = stringToArrayOutput("Today");

  // ---------------------------------------------------------
  // ⭐ 1. UI Helper: PURE JS DATE (no timezone applied)
  // ---------------------------------------------------------
  var toPureDate = function toPureDate(d) {
    return d ? new Date(d.getFullYear(), d.getMonth(), d.getDate()) : null;
  };

  // ---------------------------------------------------------
  // ⭐ 2. NORMALIZE INTO ORG TIMEZONE (calculation only)
  // ---------------------------------------------------------
  var normalizeToOrgTZ = function normalizeToOrgTZ(date, orgTZ) {
    if (!date) return null;
    return moment.tz({
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate()
    }, orgTZ).startOf("day");
  };

  // ---------------------------------------------------------
  // ⭐ 3. UI DISPLAY DATE (LOCAL pure date, never shifts)
  // ---------------------------------------------------------
  var formatDisplayDate = function formatDisplayDate(date) {
    if (!date) return "";
    return moment({
      year: date.getFullYear(),
      month: date.getMonth(),
      date: date.getDate()
    }).format("DD MMM, YYYY");
  };

  // ---------------------------------------------------------
  // ⭐ 4. MAIN LEAVE CALCULATION (ORG TIMEZONE ONLY)
  // ---------------------------------------------------------
  var getDateDetailsData = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(orgDates) {
      var _orgDates, startOrgDate, endOrgDate, orgTZ, startOrg, endOrg, daysDiff, totalLeave, details, workDayList, _loop, i;
      return _regeneratorRuntime().wrap(function _callee7$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _orgDates = _slicedToArray(orgDates, 2), startOrgDate = _orgDates[0], endOrgDate = _orgDates[1];
            if (startOrgDate) {
              _context8.next = 5;
              break;
            }
            setFieldValue("dateDetails", []);
            setFieldValue("totalLeave", 0);
            return _context8.abrupt("return");
          case 5:
            orgTZ = timeZone;
            startOrg = moment(startOrgDate).tz(orgTZ).startOf("day");
            endOrg = endOrgDate != null ? moment(endOrgDate).tz(orgTZ).startOf("day") : startOrg.clone();
            daysDiff = endOrg.diff(startOrg, "days");
            totalLeave = 0;
            details = [];
            workDayList = workingDays ? workingDays.split(",") : [];
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var currentOrg, dateKey, weekday, isWorkingDay, holidayIndex, nonWorkingSession, _holidayListData$holi2, session;
              return _regeneratorRuntime().wrap(function _loop$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    currentOrg = startOrg.clone().add(i, "days");
                    dateKey = currentOrg.format("YYYY-MM-DD");
                    weekday = currentOrg.format("dddd");
                    isWorkingDay = workDayList.length === 0 || workDayList.includes(weekday);
                    holidayIndex = holidayListData ? holidayListData.findIndex(function (h) {
                      var _h$leaveUser;
                      var holidayDate = moment.unix(h.date / 1000).tz(orgTZ).format("YYYY-MM-DD");
                      var isPublic = h.holidayVisibility === "public" || h.holidayVisibility == null;
                      var isPrivate = h.holidayVisibility === "private" && ((_h$leaveUser = h.leaveUser) === null || _h$leaveUser === void 0 ? void 0 : _h$leaveUser.some(function (u) {
                        return u.userId === userId;
                      }));
                      return (isPublic || isPrivate) && holidayDate === dateKey;
                    }) : -1; // half-day holiday on a working day: leave can only be taken for the other half
                    nonWorkingSession = null;
                    if (holidayIndex >= 0 && isWorkingDay) {
                      session = (_holidayListData$holi2 = holidayListData[holidayIndex]) === null || _holidayListData$holi2 === void 0 ? void 0 : _holidayListData$holi2.session;
                      if (session === "half-day-first-half") nonWorkingSession = "half-day-second-half";else if (session === "half-day-second-half") nonWorkingSession = "half-day-first-half";
                    }
                    if (nonWorkingSession) {
                      totalLeave += 0.5;
                    } else if (holidayIndex < 0 && isWorkingDay) {
                      totalLeave += 1;
                    }
                    details.push({
                      date: currentOrg.format("DD-MM-YYYY"),
                      dateFormat: currentOrg.format("DD MMM"),
                      dayFormat: currentOrg.format("ddd"),
                      dayType: holidayIndex >= 0 || !isWorkingDay ? "non-working-day" : "full-day",
                      nonWorkingDayLeaveSession: nonWorkingSession
                    });
                  case 9:
                  case "end":
                    return _context7.stop();
                }
              }, _loop);
            });
            i = 0;
          case 14:
            if (!(i <= daysDiff)) {
              _context8.next = 19;
              break;
            }
            return _context8.delegateYield(_loop(), "t0", 16);
          case 16:
            i++;
            _context8.next = 14;
            break;
          case 19:
            setFieldValue("dateDetails", details);
            setFieldValue("totalLeave", totalLeave);
            setNonWorkingErr(false);
            setErrorMsg("");
          case 23:
          case "end":
            return _context8.stop();
        }
      }, _callee7);
    }));
    return function getDateDetailsData(_x6) {
      return _ref13.apply(this, arguments);
    };
  }();

  // ---------------------------------------------------------
  // ⭐ 5. DatePicker selection handler (FINAL FIX)
  // ---------------------------------------------------------
  var handleDateChange = function handleDateChange(dates) {
    var _dates = _slicedToArray(dates, 2),
      rawStart = _dates[0],
      rawEnd = _dates[1];

    // 1️⃣ Save RAW dates for UI
    setDateRange(dates);
    setFieldValue("dates", dates);

    // 2️⃣ BUILD DISPLAY STRING (for the input box)
    var display = "";
    if (rawStart && !rawEnd) {
      display = formatDisplayDate(rawStart);
    }
    if (rawStart && rawEnd) {
      display = formatDisplayDate(rawStart) + " - " + formatDisplayDate(rawEnd);
    }
    setFilterData(display);

    // 3️⃣ Convert to ORG timezone dates for calculation
    var orgStart = rawStart ? normalizeToOrgTZ(rawStart, timeZone).toDate() : null;
    var orgEnd = rawEnd ? normalizeToOrgTZ(rawEnd, timeZone).toDate() : null;
    if (orgStart) {
      getDateDetailsData([orgStart, orgEnd]);
    }

    // Update holiday year tracking
    if (rawStart) {
      var yearStart = moment(rawStart).format("YYYY");
      var yearEnd = rawEnd ? moment(rawEnd).format("YYYY") : yearStart;
      if (holidayYear[0] !== yearStart || holidayYear[1] !== yearEnd) {
        setHolidayYear([yearStart, yearEnd]);
      }
    }
  };

  // ---------------------------------------------------------
  // ⭐ 6. Recalculate on holiday data load
  // ---------------------------------------------------------
  React.useEffect(function () {
    if (!holidayListData || !dateRange || !dateRange[0]) return;
    var _dateRange2 = _slicedToArray(dateRange, 2),
      s = _dateRange2[0],
      e = _dateRange2[1];
    var orgStart = s ? normalizeToOrgTZ(s, timeZone).toDate() : null;
    var orgEnd = e ? normalizeToOrgTZ(e, timeZone).toDate() : null;
    if (orgStart) getDateDetailsData([orgStart, orgEnd]);
  }, [holidayListData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-close-icon-div",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(VscClose, null)), /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-datepicker"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    selected: toPureDate(startDate),
    startDate: toPureDate(startDate),
    endDate: toPureDate(endDate),
    onChange: function onChange(dates) {
      handleDateChange(dates);
      onClose();
    },
    selectsRange: true,
    dateFormat: "dd MMM, yyyy",
    minDate: (permissionSettingData === null || permissionSettingData === void 0 ? void 0 : (_permissionSettingDat = permissionSettingData.leaveSettingsPermission) === null || _permissionSettingDat === void 0 ? void 0 : _permissionSettingDat.leavePermissions) == "false" ? datepickerPermissionForPast[0] : (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" ? datePickerMinDate[0] : ""
  }))));
}
var convertOrganisationTimezoneForFilter = function convertOrganisationTimezoneForFilter(sD, tz) {
  var currentSystemTimezone = moment.tz.guess();
  var startTime = moment(sD).tz(currentSystemTimezone).format("YYYY-MM-DD");
  //console.log("initial ,", startTime)

  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(tz).utcOffset();
  if (zoneoffset !== currentSystemOffset) {
    var zoneoffsetTemp = Math.abs(zoneoffset);
    var currentSystemOffsetTemp = Math.abs(currentSystemOffset);
    if (zoneoffset > 0) {
      zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
    } else {
      zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
    }
  }
  //console.log({zoneoffset,currentSystemOffset});

  if (zoneoffset >= 0) {
    //console.log("if",startTime);
    startTime = moment(startTime).format("DD MMM,YYYY");
    if (zoneoffset !== currentSystemOffset && zoneoffset < currentSystemOffset) {
      //console.log("inside if")
      startTime = moment(startTime).add(zoneoffset, "minutes").format("DD MMM,YYYY");
    }
  } else {
    // console.log(" else");
    // console.log({startTime});

    zoneoffset = Math.abs(zoneoffset);
    //console.log({zoneoffset})
    startTime = moment(startTime).add(zoneoffset, "minutes").format("DD MMM,YYYY");
  }
  //console.log({startTime});

  //console.log(moment(startTime));
  // let startLoopingDate = moment(startTime).tz(currentSystemTimezone).format("DD MMM,YYYY");
  // console.log({startLoopingDate});

  return startTime;
};
var arrayToStringOutput = function arrayToStringOutput(arrayData, tz) {
  var sD = arrayData[0];
  var eD = arrayData[1] ? arrayData[1] : null;
  var startDate = convertOrganisationTimezoneForFilter(sD, tz);
  var endDate = null;
  if (eD) {
    endDate = convertOrganisationTimezoneForFilter(eD, tz);
  }
  return moment(startDate).isSame(endDate, "day") ? startDate : endDate ? "".concat(startDate, " - ").concat(endDate) : startDate;
};
var formats = "h:mm a";
var ApplyPermissionSchema = Yup.object().shape({
  user: Yup.string().trim().required("Required"),
  //permissionType: Yup.string().trim().required("Required"),
  //dates: Yup.array().min(1, "Required atleast 1 date").required("Required atleast 1 date"),
  reasonForPermission: Yup.string().trim().required("Required"),
  startTime: Yup.string().trim().required("Required")
  //endTime: Yup.string().trim().required("Required"),
});
export function ApplyPermissionModal(props) {
  var applyPermissionShow = props.applyPermissionShow,
    handleApplyPermissionClose = props.handleApplyPermissionClose,
    organisationId = props.organisationId,
    timeZone = props.timeZone,
    userId = props.userId,
    activeTab = props.activeTab,
    role = props.role,
    workingDays = props.workingDays,
    currentYear = props.currentYear,
    organisationBilling = props.organisationBilling,
    last14Days = props.last14Days,
    setApplyPermissionShow = props.setApplyPermissionShow,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    leaveTypeParameterCheck = props.leaveTypeParameterCheck,
    leaveStartDateMonthFilter = props.leaveStartDateMonthFilter,
    leaveEndDateMonthFilter = props.leaveEndDateMonthFilter;
  if (applyPermissionShow == null) {
    return null;
  }
  var type = applyPermissionShow.type;
  var _React$useContext5 = React.useContext(FilterContext),
    teamId = _React$useContext5.teamId,
    leaveSettingsUser = _React$useContext5.leaveSettingsUser;
  var _React$useState51 = React.useState([]),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    userList = _React$useState52[0],
    setUserList = _React$useState52[1];
  var _React$useState53 = React.useState(userId),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    selectUserList = _React$useState54[0],
    setSelectUserList = _React$useState54[1];
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var _React$useState55 = React.useState(moment().toDate()),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    manualStartDate = _React$useState56[0],
    setManualStartDate = _React$useState56[1];
  var _React$useState57 = React.useState(false),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    isManualDatePickerOpen = _React$useState58[0],
    setIsManualDatePickerOpen = _React$useState58[1];
  var _React$useState59 = React.useState(undefined),
    _React$useState60 = _slicedToArray(_React$useState59, 2),
    modalValueEndTime = _React$useState60[0],
    setModalValueEndTime = _React$useState60[1];
  var _React$useState61 = React.useState(moment()),
    _React$useState62 = _slicedToArray(_React$useState61, 2),
    modalValueStartTime = _React$useState62[0],
    setModalValueStartTime = _React$useState62[1];
  var _React$useState63 = React.useState(undefined),
    _React$useState64 = _slicedToArray(_React$useState63, 2),
    modalValueEndTimeFindDiff = _React$useState64[0],
    setModalValueEndTimeFindDiff = _React$useState64[1];
  var _React$useState65 = React.useState(null),
    _React$useState66 = _slicedToArray(_React$useState65, 2),
    modalDateEndTime = _React$useState66[0],
    setModalDateEndTime = _React$useState66[1];
  var _React$useState67 = React.useState(null),
    _React$useState68 = _slicedToArray(_React$useState67, 2),
    modalDateStartTime = _React$useState68[0],
    setModalDateStartTime = _React$useState68[1];
  var _React$useState69 = React.useState(null),
    _React$useState70 = _slicedToArray(_React$useState69, 2),
    permissionType = _React$useState70[0],
    setPermissionType = _React$useState70[1];
  var _useQuery11 = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery11.loading,
    userListData = _useQuery11.data,
    userListError = _useQuery11.error;
  var _useQuery12 = useQuery(HOLIDAY_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        holidayType: null,
        startYear: moment().format("YYYY"),
        endYear: moment().format("YYYY"),
        limit: null,
        offset: null
      }
    }),
    holidayListData = _useQuery12.data,
    holidayListError = _useQuery12.error,
    holidayListLoading = _useQuery12.loading,
    holidayListRefetch = _useQuery12.refetch;
  var _useQuery13 = useQuery(LEAVE_SETTINGS_APPROVED_LIST_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    permissionSettingLoading = _useQuery13.loading,
    permissionSettingData = _useQuery13.data,
    permissionSettingError = _useQuery13.error;
  var _useQuery14 = useQuery(LIST_PERMISSION_TYPE_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: timeZone,
        userId: selectUserList
      },
      skip: !organisationId
    }),
    permissionTypeListData = _useQuery14.data,
    leaveTypeListError = _useQuery14.error,
    permissionTypeListLoading = _useQuery14.loading,
    leaveTypeRefetch = _useQuery14.refetch;
  React.useEffect(function () {
    if (permissionType == null) {
      setPermissionType(permissionTypeListData === null || permissionTypeListData === void 0 ? void 0 : permissionTypeListData.permissionTypeList[0].value);
    }
  }, [permissionTypeListData]);
  var _useMutation13 = useMutation(ADD_PERMISSION_DETAILS_MUTATION),
    _useMutation14 = _slicedToArray(_useMutation13, 2),
    addLeavePermission = _useMutation14[0],
    addLeavePermissionDetailsLoading = _useMutation14[1].loading;
  var _useMutation15 = useMutation(EDIT_PERMISSION_DETAILS_MUTATION),
    _useMutation16 = _slicedToArray(_useMutation15, 2),
    editLeavePermission = _useMutation16[0],
    editLeaveDetailsLoading = _useMutation16[1].loading;
  var _useState19 = useState(applyPermissionShow !== null && applyPermissionShow !== void 0 && applyPermissionShow.leaveDays && type == "edit" ? applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.leaveDays : null),
    _useState20 = _slicedToArray(_useState19, 2),
    oldTotalLeave = _useState20[0],
    setOldTotalLeave = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    nonWorkingErr = _useState22[0],
    setNonWorkingErr = _useState22[1];
  var _React$useState71 = React.useState(""),
    _React$useState72 = _slicedToArray(_React$useState71, 2),
    errorMsg = _React$useState72[0],
    setErrorMsg = _React$useState72[1];
  React.useEffect(function () {
    leaveTypeRefetch === null || leaveTypeRefetch === void 0 ? void 0 : leaveTypeRefetch();
  }, [selectUserList]);
  React.useEffect(function () {
    //console.log(applyPermissionShow?.permissionDate)
    if (applyPermissionShow !== null && applyPermissionShow !== void 0 && applyPermissionShow.permissionDate && type == "edit") {
      setManualStartDate(moment(Number(applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionDate)).toDate());
    }
    if (applyPermissionShow !== null && applyPermissionShow !== void 0 && applyPermissionShow.permissionStartTime && type == "edit") {
      setModalValueStartTime(moment(applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionStartTime));
    }
    if (applyPermissionShow !== null && applyPermissionShow !== void 0 && applyPermissionShow.permissionEndTime && type == "edit") {
      setModalValueEndTime(moment(applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionEndTime));
      setModalValueEndTimeFindDiff(moment(applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionEndTime));
    }
  }, [applyPermissionShow]);
  var _React$useContext6 = React.useContext(UserContext),
    user = _React$useContext6.user;
  var leaveSettingsCheckForUser = leaveSettingsUser && leaveSettingsUser !== null && leaveSettingsUser !== void 0 && leaveSettingsUser.approvedList.length ? leaveSettingsUser === null || leaveSettingsUser === void 0 ? void 0 : leaveSettingsUser.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  React.useEffect(function () {
    if (role == "Admin" || leaveSettingsCheckForUser && role != "Admin") {
      if (!userListLoading && !userListError) {
        var _userListData$getUser2;
        var temp = [];
        userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser2 = userListData.getUserListingForLeave) === null || _userListData$getUser2 === void 0 ? void 0 : _userListData$getUser2.map(function (item) {
          var userId = item.userId,
            displayName = item.displayName;
          return temp.push({
            label: displayName,
            value: userId
          });
        });
        setUserList(temp);
      }
    } else {
      var _temp2 = [{
        value: user.userId,
        label: user.displayName
      }];
      setUserList(_temp2);
    }
  }, [userListData]);
  var findPermissionStartAndEndDifference = function findPermissionStartAndEndDifference(modalValueStartTime, modalValueEndTime) {
    var startYear = modalValueStartTime.format("YYYY");
    var startMonth = modalValueStartTime.format("MM");
    var startDate1 = modalValueStartTime.format("DD");
    var startHours = modalValueStartTime.format("HH");
    var startMin = modalValueStartTime.format("mm");

    // console.log({ startYear, startMonth, startDate1, startHours, startMin });

    var endYear = modalValueEndTime.format("YYYY");
    var endMonth = modalValueEndTime.format("MM");
    var endDate1 = modalValueEndTime.format("DD");
    var endHours = modalValueEndTime.format("HH");
    var endMin = modalValueEndTime.format("mm");

    // console.log({ endYear, endMonth, endDate1, endHours, endMin });

    var startDate = new Date(startYear, Number(startMonth) - 1, startDate1, startHours, startMin); // January 1, 2023
    var endDate = new Date(endYear, Number(endMonth) - 1, endDate1, endHours, endMin); // January 1, 2024

    var millisecondsInAMinute = 1000 * 60;

    // Calculate the difference in milliseconds
    var millisecondsDifference = endDate - startDate;

    // console.log(`Difference in MS: ${millisecondsDifference}`);

    // Convert the difference from milliseconds to minutes
    var minutesDifference = Math.floor(millisecondsDifference / millisecondsInAMinute);

    // console.log(`Difference in minutes: ${minutesDifference}`);

    return minutesDifference;
  };
  React.useEffect(function () {
    if (modalValueEndTimeFindDiff && modalValueEndTimeFindDiff > modalValueStartTime) {
      // const totalHours = Math.round(moment.duration(moment(modalValueEndTime).diff(modalValueStartTime)).asMinutes());

      var totalHours = findPermissionStartAndEndDifference(modalValueStartTime, modalValueEndTimeFindDiff);

      // console.log({ totalHours });
      setModalDateStartTime(Number(totalHours) * 60);
      setErrorMsg("");
      //setFieldValue("totalLeave", 1);
    } else if (modalValueEndTimeFindDiff && modalValueEndTimeFindDiff <= modalValueStartTime) {
      //console.log("ele",modalValueEndTime, modalValueStartTime);
      setModalDateStartTime(null);
    }
  }, [modalValueEndTimeFindDiff, modalValueStartTime]);
  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(timeZone).utcOffset();
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(values, actions) {
      var _permissionTypeListDa;
      var user, reasonForPermission, totalLeave, startTime, endTime, startValueFormate, variables, response;
      return _regeneratorRuntime().wrap(function _callee8$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            user = values.user, reasonForPermission = values.reasonForPermission, totalLeave = values.totalLeave, startTime = values.startTime, endTime = values.endTime; //console.log({values});
            //console.log(Number(modalDateStartTime));
            if (!(manualStartDate == null)) {
              _context9.next = 4;
              break;
            }
            setNonWorkingErr(true);
            return _context9.abrupt("return", null);
          case 4:
            if (!(modalValueEndTimeFindDiff <= modalValueStartTime)) {
              _context9.next = 7;
              break;
            }
            setErrorMsg("Enter the valid short leave timings");
            return _context9.abrupt("return", null);
          case 7:
            if (!(convertSecToHoursAndMinutesWithTextForm(Number(modalDateStartTime)) == "00h 00m")) {
              _context9.next = 10;
              break;
            }
            if (!modalValueEndTimeFindDiff) {
              setErrorMsg("Enter the valid short leave end time");
            } else if (!modalValueStartTime) {
              setErrorMsg("Enter the valid short leave start time");
            } else {
              setErrorMsg("Enter the valid short leave timings");
            }
            return _context9.abrupt("return", null);
          case 10:
            startValueFormate = manualStartDate ? moment(manualStartDate).tz(timeZone).format("YYYY-MM-DD HH:mm:ss") : null;
            if (zoneoffset !== currentSystemOffset) {
              if (manualStartDate) {
                startValueFormate = convertOrganisationTimezoneForfilterDate(moment(manualStartDate).format("YYYY-MM-DD HH:mm:ss"), 0, timeZone);
              }
            }

            // return null;
            variables = {
              organisationId: organisationId,
              userId: user,
              permissionTypeId: permissionTypeListData !== null && permissionTypeListData !== void 0 && permissionTypeListData.permissionTypeList.length ? permissionTypeListData === null || permissionTypeListData === void 0 ? void 0 : (_permissionTypeListDa = permissionTypeListData.permissionTypeList[0]) === null || _permissionTypeListDa === void 0 ? void 0 : _permissionTypeListDa.value : null,
              permissionRemark: encodeHtmlEntities(reasonForPermission),
              timeZone: timeZone,
              startTime: startTime,
              endTime: endTime,
              permissionDate: startValueFormate
            };
            _context9.prev = 13;
            _context9.next = 16;
            return addLeavePermission({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_CHART_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  year: currentYear,
                  timeZone: timeZone
                }
              }, {
                query: LEAVE_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  filter: activeTab,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  timeZone: timeZone,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_TYPE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  startTime: Number(leaveBalanceStartDate),
                  endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate)
                }
              }, {
                query: LIST_LEAVE_TYPE_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  userId: selectUserList
                }
              }]
            });
          case 16:
            response = _context9.sent;
            if (!response || !response.data || response.data.addLeavePermission == false) {
              toast.error("Error Occured, Try again later!");
            } else {
              handleApplyPermissionClose();
              setOldTotalLeave(null);
              setApplyPermissionShow(null);
              actions.resetForm();
              // setDateRange([null, null]);
              // setFilterData(null);
              setManualStartDate(new Date());
              toast.success("Short Leave added successfully!");
            }
            _context9.next = 23;
            break;
          case 20:
            _context9.prev = 20;
            _context9.t0 = _context9["catch"](13);
            // The server's own wording is shown under the Apply Short Leave button -
            // the 5-per-minute limit from checkShortLeavesTypePerMinCount says
            // exactly what to do, so the generic toast alongside it would read as a
            // second, unrelated failure. Toast only when there is nothing to show.
            //
            // addLeavePermission is also capped by the leave-permission-adds limiter
            // in the middleware, which answers 429. Apollo surfaces a non-2xx as a
            // *network* error, so that reason never reaches error.message - it would
            // read "Response not successful: Received status code 429". The limiter's
            // own text has to be read out of the 429 body instead, which keeps the
            // window right if that limit is ever retuned.
            if (isRateLimited(_context9.t0)) {
              setErrorMsg(rateLimitMessage(_context9.t0, "You’ve reached the limit of 5 requests per minute. Please try again in a minute."));
            } else if (_context9.t0.message) {
              setErrorMsg(_context9.t0.message);
            } else {
              toast.error("Error Occured, Try again later!");
            }
          case 23:
          case "end":
            return _context9.stop();
        }
      }, _callee8, null, [[13, 20]]);
    }));
    return function (_x7, _x8) {
      return _ref14.apply(this, arguments);
    };
  }(), [addLeavePermission, addLeavePermissionDetailsLoading, manualStartDate, permissionType, modalValueEndTimeFindDiff, modalValueStartTime, modalDateStartTime]);
  var handleEditSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(values, actions) {
      var _permissionTypeListDa2;
      var user, reasonForPermission, totalLeave, startTime, endTime, variables, response;
      return _regeneratorRuntime().wrap(function _callee9$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            user = values.user, reasonForPermission = values.reasonForPermission, totalLeave = values.totalLeave, startTime = values.startTime, endTime = values.endTime;
            if (!(manualStartDate == null)) {
              _context10.next = 4;
              break;
            }
            setNonWorkingErr(true);
            return _context10.abrupt("return", null);
          case 4:
            if (!(modalValueEndTime <= modalValueStartTime)) {
              _context10.next = 7;
              break;
            }
            setErrorMsg("Enter the valid short leave timings");
            return _context10.abrupt("return", null);
          case 7:
            if (!(convertSecToHoursAndMinutesWithTextForm(Number(modalDateStartTime)) == "00h 00m")) {
              _context10.next = 10;
              break;
            }
            setErrorMsg("Enter the valid short leave timings");
            return _context10.abrupt("return", null);
          case 10:
            variables = {
              organisationId: organisationId,
              userId: user,
              permissionTypeId: permissionTypeListData !== null && permissionTypeListData !== void 0 && permissionTypeListData.permissionTypeList.length ? permissionTypeListData === null || permissionTypeListData === void 0 ? void 0 : (_permissionTypeListDa2 = permissionTypeListData.permissionTypeList[0]) === null || _permissionTypeListDa2 === void 0 ? void 0 : _permissionTypeListDa2.value : null,
              permissionRemark: encodeHtmlEntities(reasonForPermission),
              timeZone: timeZone,
              startTime: startTime,
              endTime: endTime,
              permissionDate: moment(manualStartDate).valueOf(),
              permissionId: applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionId,
              oldPermissionDate: Number(applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionDate)
            };
            _context10.prev = 11;
            _context10.next = 14;
            return editLeavePermission({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_CHART_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  year: currentYear,
                  timeZone: timeZone
                }
              }, {
                query: LEAVE_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  filter: activeTab,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && activeTab == "past" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userId,
                  timeZone: timeZone,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
                  leaveType: leaveTypeParameterCheck ? leaveTypeParameterCheck.value : null,
                  startTime: leaveStartDateMonthFilter,
                  endTime: leaveEndDateMonthFilter
                }
              }, {
                query: LEAVE_TYPE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  startTime: Number(leaveBalanceStartDate),
                  endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate)
                }
              }]
            });
          case 14:
            response = _context10.sent;
            if (!response || !response.data || response.data.editLeavePermission == false) {
              toast.error("Error Occured, Try again later!");
            } else {
              handleApplyPermissionClose();
              setOldTotalLeave(null);
              setApplyPermissionShow(null);
              //actions.resetForm();
              setManualStartDate(new Date());
              toast.success("Short leave edited successfully!");
            }
            _context10.next = 22;
            break;
          case 18:
            _context10.prev = 18;
            _context10.t0 = _context10["catch"](11);
            if (_context10.t0.message !== "") {
              setErrorMsg(_context10.t0.message);
            }
            toast.error("Error Occured, Try again later!");
          case 22:
          case "end":
            return _context10.stop();
        }
      }, _callee9, null, [[11, 18]]);
    }));
    return function (_x9, _x10) {
      return _ref15.apply(this, arguments);
    };
  }(), [editLeavePermission, editLeaveDetailsLoading, applyPermissionShow, manualStartDate, permissionType, modalValueEndTime, modalValueStartTime, modalDateStartTime]);
  var hideOverlay = function hideOverlay() {
    var _document4, _document4$body, _document4$body$click;
    (_document4 = document) === null || _document4 === void 0 ? void 0 : (_document4$body = _document4.body) === null || _document4$body === void 0 ? void 0 : (_document4$body$click = _document4$body.click) === null || _document4$body$click === void 0 ? void 0 : _document4$body$click.call(_document4$body);
  };
  var applyPermissionModalClose = function applyPermissionModalClose() {
    // setDateRange([null, null]);
    // setFilterData(null);
    setErrorMsg("");
    setNonWorkingErr(false);
    handleApplyPermissionClose();
    setOldTotalLeave(null);
    setApplyPermissionShow(null);
    setModalDateStartTime(null);
    setManualStartDate(new Date());
    //setModalDateStartTime(null);
  };
  var handleChange = function handleChange(e) {
    setIsManualDatePickerOpen(!isManualDatePickerOpen);
    setManualStartDate(e);
  };
  var startOnChange = function startOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setModalValueStartTime(value);
      setFieldValue("startTime", finalTime);
    } else {
      setFieldValue("startTime", "");
    }
  };
  var endOnChange = function endOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      var dateTemp = moment(manualStartDate).format("DD/MM/YYYY");
      var currentDate = moment().format("DD/MM/YYYY");
      setModalValueEndTime(value);
      // setModalEndTime(finalTime);
      setFieldValue("endTime", finalTime);
      setModalDateEndTime(moment(dateTemp + " " + finalTime, "DD/MM/YYYY HH:mm").valueOf());
      setModalValueEndTimeFindDiff(moment(currentDate + " " + finalTime, "DD/MM/YYYY HH:mm"));
    } else {
      setModalValueEndTime(undefined);
      setModalValueEndTimeFindDiff(undefined);
      setFieldValue("endTime", "");
      setModalDateEndTime(null);
    }
  };
  var datePickerMinDate = stringToArrayOutput("Free Plan Days");
  var datepickerPermissionForPast = stringToArrayOutput("Today");
  return /*#__PURE__*/React.createElement(Modal, {
    show: applyPermissionShow == false ? false : true,
    onHide: applyPermissionModalClose,
    animation: false,
    size: "md",
    backdrop: "static",
    className: "apply-leave-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "apply-leave-modal-header-title"
  }, type == "add" ? "Apply Short Leave" : "Edit Short Leave")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "apply-leave-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      user: type == "edit" ? userId : userId,
      //permissionType: type == "edit" ? applyPermissionShow?.permissionTypeId : "",
      //dates: type == "edit" ? [Number(applyPermissionShow?.leaveStartDate), Number(applyPermissionShow?.leaveEndDate)] : [],
      reasonForPermission: type == "edit" ? decodeHtmlEntities(applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionRemark) : "",
      //totalLeave: type == "edit" ? applyPermissionShow?.leaveDays : 0,
      startTime: type == "edit" ? moment(applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionStartTime).format("HH:mm") : moment().format("HH:mm"),
      endTime: type == "edit" ? moment(applyPermissionShow === null || applyPermissionShow === void 0 ? void 0 : applyPermissionShow.permissionEndTime).format("HH:mm") : ""
    },
    validationSchema: ApplyPermissionSchema,
    onSubmit: type !== "edit" ? handleSubmit : handleEditSubmit
    //onSubmit={handleSubmit}
  }, function (_ref16) {
    var setFieldValue = _ref16.setFieldValue,
      errors = _ref16.errors,
      touched = _ref16.touched,
      values = _ref16.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form-div"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, role == "Admin" || leaveSettingsCheckForUser && role != "Admin" ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "user"
    }, function (_ref17) {
      var field = _ref17.field,
        form = _ref17.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Employee Name"), errors.user && touched.user ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error apply-leave-modal-error"
      }, errors.user) : null, /*#__PURE__*/React.createElement(FormControl, {
        as: "select",
        className: "apply-leave-modal-body-wrapper-form-div-field-input",
        onChange: function onChange(e) {
          setFieldValue("user", e.target.value);
          setSelectUserList(e.target.value);
        },
        value: values.user
        //{...field}
      }, /*#__PURE__*/React.createElement("option", {
        key: "select-user",
        value: " "
      }, "Select User"), userList === null || userList === void 0 ? void 0 : userList.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.label);
      })));
    }))) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "dates"
    }, function (_ref18) {
      var _permissionSettingDat2;
      var field = _ref18.field,
        form = _ref18.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "apply-leave-modal-body-wrapper-form-div-field-form-group"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Short Leave Date"), errors.dates && touched.dates ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error apply-leave-modal-error"
      }, errors.dates) : null, /*#__PURE__*/React.createElement(OverlayTrigger, {
        trigger: "click",
        rootClose: true,
        placement: "bottom",
        overlay: /*#__PURE__*/React.createElement(Popover, {
          className: "project-task-time-mapping-wrapper-menu-filter-overlay-trigger"
        }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(DatePicker, {
          selected: manualStartDate,
          onChange: handleChange,
          open: isManualDatePickerOpen,
          inline: true
          //maxDate={new Date()}
          ,
          minDate: (permissionSettingData === null || permissionSettingData === void 0 ? void 0 : (_permissionSettingDat2 = permissionSettingData.leaveSettingsPermission) === null || _permissionSettingDat2 === void 0 ? void 0 : _permissionSettingDat2.leavePermissions) == "false" ? datepickerPermissionForPast[0] : (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" ? datePickerMinDate[0] : ""
        })))
      }, /*#__PURE__*/React.createElement("div", {
        id: "date-filter",
        className: "apply-leave-modal-body-wrapper-form-date-picker-filter-date apply-leave-modal-body-wrapper-form-div-field-input"
      }, /*#__PURE__*/React.createElement(MdDateRange, {
        className: "apply-leave-modal-body-wrapper-form-date-picker-filter-date-icon"
      }), arrayToStringOutput([manualStartDate, manualStartDate]) ? /*#__PURE__*/React.createElement("p", {
        className: "apply-leave-modal-body-wrapper-form-date-picker-filter-date-text"
      }, arrayToStringOutput([manualStartDate, manualStartDate])) : /*#__PURE__*/React.createElement("p", {
        className: "apply-leave-modal-body-wrapper-form-date-picker-filter-date-text"
      }, "Select Date"))));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "reasonForPermission"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name "
      }, "Remark"), /*#__PURE__*/React.createElement("span", {
        className: "my-projects-modal-label-name-required"
      }, " *"), errors.reasonForPermission && touched.reasonForPermission ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error apply-leave-modal-error"
      }, errors.reasonForPermission) : null, /*#__PURE__*/React.createElement("textarea", _extends({
        className: "text-area apply-leave-modal-body-wrapper-form-field-text-area"
      }, field, fieldProps)));
    }))))))), /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
    }, "Your Short Leave Details"), /*#__PURE__*/React.createElement("div", {
      className: role == "Member" ? "permission-modal-body-wrapper-summary-content-member" : "permission-modal-body-wrapper-summary-content"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "startTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name "
      }, "Start Time"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "startTime",
        value: modalValueStartTime,
        className: meta.error && meta.touched ? "project-task-time-mapping-formik-add-form-start-time-error" : "project-task-time-mapping-formik-add-form-start-time",
        onChange: function onChange(e) {
          startOnChange(e, setFieldValue);
          //setStartTimeTemp(e);
        },
        placeholder: "Start Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
        // disabledHours={disabledStartTimeHours}
        // disabledMinutes={disabledStartTimeMinutes}
      })));
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "endTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      //console.log("err", meta.error);

      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name "
      }, "End Time"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "endTime",
        value: modalValueEndTime,
        className: meta.error && meta.touched ? "project-task-time-mapping-formik-add-form-start-time-error" : "project-task-time-mapping-formik-add-form-start-time",
        onChange: function onChange(e) {
          endOnChange(e, setFieldValue);
          //setEndTimeTemp(e);
        },
        placeholder: "End Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
        // disabledHours={disabledHours}
        // disabledMinutes={disabledMinutes}
      }), /*#__PURE__*/React.createElement("div", {
        className: "manual-home-project-formik-add-form-edit-end-time"
      }, modalValueEndTimeFindDiff && modalValueEndTimeFindDiff < modalValueStartTime ? "End time should be greater than the start time" : "")));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-summary-footer"
    }, /*#__PURE__*/React.createElement("div", null, "Total Short Leave Duration"), /*#__PURE__*/React.createElement("div", null, convertSecToHoursAndMinutesWithTextForm(Number(modalDateStartTime)))))), /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-modal-body-wrapper-form-footer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button"
    }, nonWorkingErr ? /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-text"
    }, "Choose the valid day to apply the short Leave") : null, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "apply-leave-footer-apply-leave-button",
      type: "submit",
      disabled: addLeavePermissionDetailsLoading || editLeaveDetailsLoading
    }, addLeavePermissionDetailsLoading || editLeaveDetailsLoading ? "Loading..." : type == "add" ? "Apply Short Leave" : "Update Changes"), errorMsg !== "" ? /*#__PURE__*/React.createElement("div", {
      className: "apply-leave-footer-apply-leave-button-text"
    }, " ", errorMsg) : null)));
  })));
}
var convertOrganisationTimezoneForFilterApply = function convertOrganisationTimezoneForFilterApply(sD, tz) {
  var currentSystemTimezone = moment.tz.guess();
  var startTime = moment(sD).tz(currentSystemTimezone).format("YYYY-MM-DD");
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(tz).utcOffset();
  if (zoneoffset !== currentSystemOffset) {
    var zoneoffsetTemp = Math.abs(zoneoffset);
    var currentSystemOffsetTemp = Math.abs(currentSystemOffset);
    if (zoneoffset > 0) {
      zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
    } else {
      zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
    }
  }
  if (zoneoffset >= 0) {
    startTime = moment(startTime).format("MMM,YYYY");
    if (zoneoffset !== currentSystemOffset && zoneoffset < currentSystemOffset) {
      startTime = moment(startTime).add(zoneoffset, "minutes").format("MMM,YYYY");
    }
  } else {
    zoneoffset = Math.abs(zoneoffset);
    startTime = moment(startTime).add(zoneoffset, "minutes").format("MMM,YYYY");
  }

  //let startLoopingDate = moment(startTime).tz(currentSystemTimezone).format("MMM,YYYY");

  return startTime;
};
var arrayToStringOutputApply = function arrayToStringOutputApply(arrayData, tz) {
  var sD = arrayData[0];
  var eD = arrayData[1] ? arrayData[1] : null;
  var startDate = convertOrganisationTimezoneForFilterApply(sD, tz);
  var endDate = null;
  if (eD) {
    endDate = convertOrganisationTimezoneForFilterApply(eD, tz);
  }
  return moment(startDate).isSame(endDate, "day") ? startDate : endDate ? "".concat(startDate, " - ").concat(endDate) : startDate;
};
function TimeFilterBalance(props) {
  var onClose = props.onClose,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    setLeaveBalanceStartDate = props.setLeaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    setLeaveBalanceEndDate = props.setLeaveBalanceEndDate;
  var handleDateChange = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
      return _regeneratorRuntime().wrap(function _callee10$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            setLeaveBalanceStartDate(e[0]);
            setLeaveBalanceEndDate(e[1]);
          case 2:
          case "end":
            return _context11.stop();
        }
      }, _callee10);
    }));
    return function handleDateChange(_x11) {
      return _ref19.apply(this, arguments);
    };
  }();
  var datePickerMinDate = stringToArrayOutput("Free Plan Days");
  var datepickerPermissionForPast = stringToArrayOutput("Today");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-datepicker"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    selected: leaveBalanceStartDate,
    onChange: function onChange(e) {
      handleDateChange(e);
      //handleFilterChange(e);
    },
    startDate: leaveBalanceStartDate,
    endDate: leaveBalanceEndDate,
    selectsRange: true,
    showMonthYearPicker: true
    // minDate={
    //   permissionSettingData?.leaveSettingsPermission?.leavePermissions == "false"
    //     ? datepickerPermissionForPast[0]
    //     : organisationBilling?.planName == "free" || organisationBilling?.planStatus == "stopped"
    //     ? datePickerMinDate[0]
    //     : ""
    // }
  }))));
}
export default ViewLeave;